import { cabinetApi as api } from "../api";
export const addTagTypes = [
  "Company",
  "CompanyCategory",
  "ContactCadence",
  "ContactCategory",
  "ContactEmail",
  "ContactEvents",
  "ContactFieldChoice",
  "ContactFieldOrder",
  "ContactFieldTemplate",
  "ContactNote",
  "Tag",
  "ContactTask",
  "ContactType",
  "Contact",
  "EventBrief",
  "EventBriefExternal",
  "LeaderRelationship",
  "CrmPreferences",
  "LeaderPrivateContact",
  "RelationshipTag",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      appCrmCompaniesList: build.query<
        AppCrmCompaniesListApiResponse,
        AppCrmCompaniesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/companies/`,
          params: {
            hidden_date: queryArg.hiddenDate,
            hidden_date_gt: queryArg.hiddenDateGt,
            hidden_date_gte: queryArg.hiddenDateGte,
            hidden_date_in: queryArg.hiddenDateIn,
            hidden_date_isnull: queryArg.hiddenDateIsnull,
            hidden_date_lt: queryArg.hiddenDateLt,
            hidden_date_lte: queryArg.hiddenDateLte,
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            name: queryArg.name,
            name_contains: queryArg.nameContains,
            name_endswith: queryArg.nameEndswith,
            name_icontains: queryArg.nameIcontains,
            name_iexact: queryArg.nameIexact,
            name_in: queryArg.nameIn,
            name_ine: queryArg.nameIne,
            name_isempty: queryArg.nameIsempty,
            name_isnull: queryArg.nameIsnull,
            name_ne: queryArg.nameNe,
            name_not_contains: queryArg.nameNotContains,
            name_not_icontains: queryArg.nameNotIcontains,
            name_startswith: queryArg.nameStartswith,
            offset: queryArg.offset,
            order_by: queryArg.orderBy,
            search: queryArg.search,
            search_contains: queryArg.searchContains,
            search_endswith: queryArg.searchEndswith,
            search_icontains: queryArg.searchIcontains,
            search_iexact: queryArg.searchIexact,
            search_in: queryArg.searchIn,
            search_ine: queryArg.searchIne,
            search_isempty: queryArg.searchIsempty,
            search_isnull: queryArg.searchIsnull,
            search_ne: queryArg.searchNe,
            search_not_contains: queryArg.searchNotContains,
            search_not_icontains: queryArg.searchNotIcontains,
            search_startswith: queryArg.searchStartswith,
          },
        }),
        providesTags: ["Company"],
      }),
      appCrmCompaniesCreate: build.mutation<
        AppCrmCompaniesCreateApiResponse,
        AppCrmCompaniesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/companies/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Company"],
      }),
      appCrmCompaniesRetrieve: build.query<
        AppCrmCompaniesRetrieveApiResponse,
        AppCrmCompaniesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/companies/${queryArg}/`,
        }),
        providesTags: ["Company"],
      }),
      appCrmCompaniesUpdate: build.mutation<
        AppCrmCompaniesUpdateApiResponse,
        AppCrmCompaniesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/companies/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.companyRequest,
        }),
        invalidatesTags: ["Company"],
      }),
      appCrmCompaniesPartialUpdate: build.mutation<
        AppCrmCompaniesPartialUpdateApiResponse,
        AppCrmCompaniesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/companies/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedCompany,
        }),
        invalidatesTags: ["Company"],
      }),
      appCrmCompaniesDestroy: build.mutation<
        AppCrmCompaniesDestroyApiResponse,
        AppCrmCompaniesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/companies/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["Company"],
      }),
      appCrmCompanyCategoriesList: build.query<
        AppCrmCompanyCategoriesListApiResponse,
        AppCrmCompanyCategoriesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/company-categories/`,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            name: queryArg.name,
            name_contains: queryArg.nameContains,
            name_endswith: queryArg.nameEndswith,
            name_icontains: queryArg.nameIcontains,
            name_iexact: queryArg.nameIexact,
            name_in: queryArg.nameIn,
            name_ine: queryArg.nameIne,
            name_isempty: queryArg.nameIsempty,
            name_isnull: queryArg.nameIsnull,
            name_ne: queryArg.nameNe,
            name_not_contains: queryArg.nameNotContains,
            name_not_icontains: queryArg.nameNotIcontains,
            name_startswith: queryArg.nameStartswith,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["CompanyCategory"],
      }),
      appCrmCompanyCategoriesCreate: build.mutation<
        AppCrmCompanyCategoriesCreateApiResponse,
        AppCrmCompanyCategoriesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/company-categories/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["CompanyCategory"],
      }),
      appCrmCompanyCategoriesRetrieve: build.query<
        AppCrmCompanyCategoriesRetrieveApiResponse,
        AppCrmCompanyCategoriesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/company-categories/${queryArg}/`,
        }),
        providesTags: ["CompanyCategory"],
      }),
      appCrmCompanyCategoriesUpdate: build.mutation<
        AppCrmCompanyCategoriesUpdateApiResponse,
        AppCrmCompanyCategoriesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/company-categories/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.companyCategoryRequest,
        }),
        invalidatesTags: ["CompanyCategory"],
      }),
      appCrmCompanyCategoriesPartialUpdate: build.mutation<
        AppCrmCompanyCategoriesPartialUpdateApiResponse,
        AppCrmCompanyCategoriesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/company-categories/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedCompanyCategory,
        }),
        invalidatesTags: ["CompanyCategory"],
      }),
      appCrmCompanyCategoriesDestroy: build.mutation<
        AppCrmCompanyCategoriesDestroyApiResponse,
        AppCrmCompanyCategoriesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/company-categories/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["CompanyCategory"],
      }),
      appCrmContactCadenceList: build.query<
        AppCrmContactCadenceListApiResponse,
        AppCrmContactCadenceListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-cadence/`,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["ContactCadence"],
      }),
      appCrmContactCadenceCreate: build.mutation<
        AppCrmContactCadenceCreateApiResponse,
        AppCrmContactCadenceCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-cadence/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactCadence"],
      }),
      appCrmContactCadenceRetrieve: build.query<
        AppCrmContactCadenceRetrieveApiResponse,
        AppCrmContactCadenceRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-cadence/${queryArg}/`,
        }),
        providesTags: ["ContactCadence"],
      }),
      appCrmContactCadenceUpdate: build.mutation<
        AppCrmContactCadenceUpdateApiResponse,
        AppCrmContactCadenceUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-cadence/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactCadenceRequest,
        }),
        invalidatesTags: ["ContactCadence"],
      }),
      appCrmContactCadencePartialUpdate: build.mutation<
        AppCrmContactCadencePartialUpdateApiResponse,
        AppCrmContactCadencePartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-cadence/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContactCadence,
        }),
        invalidatesTags: ["ContactCadence"],
      }),
      appCrmContactCadenceDestroy: build.mutation<
        AppCrmContactCadenceDestroyApiResponse,
        AppCrmContactCadenceDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-cadence/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactCadence"],
      }),
      appCrmContactCategoriesList: build.query<
        AppCrmContactCategoriesListApiResponse,
        AppCrmContactCategoriesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-categories/`,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            name: queryArg.name,
            name_contains: queryArg.nameContains,
            name_endswith: queryArg.nameEndswith,
            name_icontains: queryArg.nameIcontains,
            name_iexact: queryArg.nameIexact,
            name_in: queryArg.nameIn,
            name_ine: queryArg.nameIne,
            name_isempty: queryArg.nameIsempty,
            name_isnull: queryArg.nameIsnull,
            name_ne: queryArg.nameNe,
            name_not_contains: queryArg.nameNotContains,
            name_not_icontains: queryArg.nameNotIcontains,
            name_startswith: queryArg.nameStartswith,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["ContactCategory"],
      }),
      appCrmContactCategoriesCreate: build.mutation<
        AppCrmContactCategoriesCreateApiResponse,
        AppCrmContactCategoriesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-categories/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactCategory"],
      }),
      appCrmContactCategoriesRetrieve: build.query<
        AppCrmContactCategoriesRetrieveApiResponse,
        AppCrmContactCategoriesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-categories/${queryArg}/`,
        }),
        providesTags: ["ContactCategory"],
      }),
      appCrmContactCategoriesUpdate: build.mutation<
        AppCrmContactCategoriesUpdateApiResponse,
        AppCrmContactCategoriesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-categories/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.tagRequest,
        }),
        invalidatesTags: ["ContactCategory"],
      }),
      appCrmContactCategoriesPartialUpdate: build.mutation<
        AppCrmContactCategoriesPartialUpdateApiResponse,
        AppCrmContactCategoriesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-categories/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedTag,
        }),
        invalidatesTags: ["ContactCategory"],
      }),
      appCrmContactCategoriesDestroy: build.mutation<
        AppCrmContactCategoriesDestroyApiResponse,
        AppCrmContactCategoriesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-categories/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactCategory"],
      }),
      appCrmContactEmailsList: build.query<
        AppCrmContactEmailsListApiResponse,
        AppCrmContactEmailsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-emails/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["ContactEmail"],
      }),
      appCrmContactEmailsCreate: build.mutation<
        AppCrmContactEmailsCreateApiResponse,
        AppCrmContactEmailsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-emails/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactEmail"],
      }),
      appCrmContactEmailsRetrieve: build.query<
        AppCrmContactEmailsRetrieveApiResponse,
        AppCrmContactEmailsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-emails/${queryArg}/`,
        }),
        providesTags: ["ContactEmail"],
      }),
      appCrmContactEmailsUpdate: build.mutation<
        AppCrmContactEmailsUpdateApiResponse,
        AppCrmContactEmailsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-emails/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactEmailRequest,
        }),
        invalidatesTags: ["ContactEmail"],
      }),
      appCrmContactEmailsPartialUpdate: build.mutation<
        AppCrmContactEmailsPartialUpdateApiResponse,
        AppCrmContactEmailsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-emails/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContactEmail,
        }),
        invalidatesTags: ["ContactEmail"],
      }),
      appCrmContactEmailsDestroy: build.mutation<
        AppCrmContactEmailsDestroyApiResponse,
        AppCrmContactEmailsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-emails/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactEmail"],
      }),
      appCrmContactEventsList: build.query<
        AppCrmContactEventsListApiResponse,
        AppCrmContactEventsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-events/`,
          params: {
            attendees: queryArg.attendees,
            attendees_in: queryArg.attendeesIn,
            attendees_isnull: queryArg.attendeesIsnull,
            distinct: queryArg.distinct,
            distinct_in: queryArg.distinctIn,
            distinct_isnull: queryArg.distinctIsnull,
            end_date: queryArg.endDate,
            end_date_gt: queryArg.endDateGt,
            end_date_gte: queryArg.endDateGte,
            end_date_in: queryArg.endDateIn,
            end_date_isnull: queryArg.endDateIsnull,
            end_date_lt: queryArg.endDateLt,
            end_date_lte: queryArg.endDateLte,
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            leaders: queryArg.leaders,
            leaders_in: queryArg.leadersIn,
            leaders_isnull: queryArg.leadersIsnull,
            limit: queryArg.limit,
            offset: queryArg.offset,
            order_by: queryArg.orderBy,
            start_date: queryArg.startDate,
            start_date_gt: queryArg.startDateGt,
            start_date_gte: queryArg.startDateGte,
            start_date_in: queryArg.startDateIn,
            start_date_isnull: queryArg.startDateIsnull,
            start_date_lt: queryArg.startDateLt,
            start_date_lte: queryArg.startDateLte,
            title: queryArg.title,
            title_contains: queryArg.titleContains,
            title_endswith: queryArg.titleEndswith,
            title_icontains: queryArg.titleIcontains,
            title_iexact: queryArg.titleIexact,
            title_in: queryArg.titleIn,
            title_ine: queryArg.titleIne,
            title_isempty: queryArg.titleIsempty,
            title_isnull: queryArg.titleIsnull,
            title_ne: queryArg.titleNe,
            title_not_contains: queryArg.titleNotContains,
            title_not_icontains: queryArg.titleNotIcontains,
            title_startswith: queryArg.titleStartswith,
          },
        }),
        providesTags: ["ContactEvents"],
      }),
      appCrmContactFieldChoicesList: build.query<
        AppCrmContactFieldChoicesListApiResponse,
        AppCrmContactFieldChoicesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-choices/`,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            label: queryArg.label,
            label_contains: queryArg.labelContains,
            label_endswith: queryArg.labelEndswith,
            label_icontains: queryArg.labelIcontains,
            label_iexact: queryArg.labelIexact,
            label_in: queryArg.labelIn,
            label_ine: queryArg.labelIne,
            label_isempty: queryArg.labelIsempty,
            label_isnull: queryArg.labelIsnull,
            label_ne: queryArg.labelNe,
            label_not_contains: queryArg.labelNotContains,
            label_not_icontains: queryArg.labelNotIcontains,
            label_startswith: queryArg.labelStartswith,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["ContactFieldChoice"],
      }),
      appCrmContactFieldChoicesCreate: build.mutation<
        AppCrmContactFieldChoicesCreateApiResponse,
        AppCrmContactFieldChoicesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-choices/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactFieldChoice"],
      }),
      appCrmContactFieldChoicesRetrieve: build.query<
        AppCrmContactFieldChoicesRetrieveApiResponse,
        AppCrmContactFieldChoicesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-choices/${queryArg}/`,
        }),
        providesTags: ["ContactFieldChoice"],
      }),
      appCrmContactFieldChoicesUpdate: build.mutation<
        AppCrmContactFieldChoicesUpdateApiResponse,
        AppCrmContactFieldChoicesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-choices/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactFieldChoiceRequest,
        }),
        invalidatesTags: ["ContactFieldChoice"],
      }),
      appCrmContactFieldChoicesPartialUpdate: build.mutation<
        AppCrmContactFieldChoicesPartialUpdateApiResponse,
        AppCrmContactFieldChoicesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-choices/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContactFieldChoice,
        }),
        invalidatesTags: ["ContactFieldChoice"],
      }),
      appCrmContactFieldChoicesDestroy: build.mutation<
        AppCrmContactFieldChoicesDestroyApiResponse,
        AppCrmContactFieldChoicesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-choices/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactFieldChoice"],
      }),
      appCrmContactFieldChoicesBulkDeleteCreate: build.mutation<
        AppCrmContactFieldChoicesBulkDeleteCreateApiResponse,
        AppCrmContactFieldChoicesBulkDeleteCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-choices/bulk-delete/`,
          method: "POST",
          body: queryArg.body,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            label: queryArg.label,
            label_contains: queryArg.labelContains,
            label_endswith: queryArg.labelEndswith,
            label_icontains: queryArg.labelIcontains,
            label_iexact: queryArg.labelIexact,
            label_in: queryArg.labelIn,
            label_ine: queryArg.labelIne,
            label_isempty: queryArg.labelIsempty,
            label_isnull: queryArg.labelIsnull,
            label_ne: queryArg.labelNe,
            label_not_contains: queryArg.labelNotContains,
            label_not_icontains: queryArg.labelNotIcontains,
            label_startswith: queryArg.labelStartswith,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        invalidatesTags: ["ContactFieldChoice"],
      }),
      appCrmContactFieldChoicesBulkUpsertCreate: build.mutation<
        AppCrmContactFieldChoicesBulkUpsertCreateApiResponse,
        AppCrmContactFieldChoicesBulkUpsertCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-choices/bulk-upsert/`,
          method: "POST",
          body: queryArg.body,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            label: queryArg.label,
            label_contains: queryArg.labelContains,
            label_endswith: queryArg.labelEndswith,
            label_icontains: queryArg.labelIcontains,
            label_iexact: queryArg.labelIexact,
            label_in: queryArg.labelIn,
            label_ine: queryArg.labelIne,
            label_isempty: queryArg.labelIsempty,
            label_isnull: queryArg.labelIsnull,
            label_ne: queryArg.labelNe,
            label_not_contains: queryArg.labelNotContains,
            label_not_icontains: queryArg.labelNotIcontains,
            label_startswith: queryArg.labelStartswith,
            limit: queryArg.limit,
            offset: queryArg.offset,
          },
        }),
        invalidatesTags: ["ContactFieldChoice"],
      }),
      appCrmContactFieldOrdersList: build.query<
        AppCrmContactFieldOrdersListApiResponse,
        AppCrmContactFieldOrdersListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-orders/`,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            offset: queryArg.offset,
            order: queryArg.order,
            order_gt: queryArg.orderGt,
            order_gte: queryArg.orderGte,
            order_in: queryArg.orderIn,
            order_isnull: queryArg.orderIsnull,
            order_lt: queryArg.orderLt,
            order_lte: queryArg.orderLte,
          },
        }),
        providesTags: ["ContactFieldOrder"],
      }),
      appCrmContactFieldOrdersCreate: build.mutation<
        AppCrmContactFieldOrdersCreateApiResponse,
        AppCrmContactFieldOrdersCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-orders/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactFieldOrder"],
      }),
      appCrmContactFieldOrdersRetrieve: build.query<
        AppCrmContactFieldOrdersRetrieveApiResponse,
        AppCrmContactFieldOrdersRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-orders/${queryArg}/`,
        }),
        providesTags: ["ContactFieldOrder"],
      }),
      appCrmContactFieldOrdersUpdate: build.mutation<
        AppCrmContactFieldOrdersUpdateApiResponse,
        AppCrmContactFieldOrdersUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-orders/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactFieldOrderRequest,
        }),
        invalidatesTags: ["ContactFieldOrder"],
      }),
      appCrmContactFieldOrdersPartialUpdate: build.mutation<
        AppCrmContactFieldOrdersPartialUpdateApiResponse,
        AppCrmContactFieldOrdersPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-orders/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContactFieldOrder,
        }),
        invalidatesTags: ["ContactFieldOrder"],
      }),
      appCrmContactFieldOrdersDestroy: build.mutation<
        AppCrmContactFieldOrdersDestroyApiResponse,
        AppCrmContactFieldOrdersDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-orders/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactFieldOrder"],
      }),
      appCrmContactFieldTemplatesList: build.query<
        AppCrmContactFieldTemplatesListApiResponse,
        AppCrmContactFieldTemplatesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-templates/`,
          params: {
            limit: queryArg.limit,
            offset: queryArg.offset,
            value_type: queryArg.valueType,
            value_type_contains: queryArg.valueTypeContains,
            value_type_endswith: queryArg.valueTypeEndswith,
            value_type_icontains: queryArg.valueTypeIcontains,
            value_type_iexact: queryArg.valueTypeIexact,
            value_type_in: queryArg.valueTypeIn,
            value_type_ine: queryArg.valueTypeIne,
            value_type_isempty: queryArg.valueTypeIsempty,
            value_type_isnull: queryArg.valueTypeIsnull,
            value_type_ne: queryArg.valueTypeNe,
            value_type_not_contains: queryArg.valueTypeNotContains,
            value_type_not_icontains: queryArg.valueTypeNotIcontains,
            value_type_startswith: queryArg.valueTypeStartswith,
          },
        }),
        providesTags: ["ContactFieldTemplate"],
      }),
      appCrmContactFieldTemplatesCreate: build.mutation<
        AppCrmContactFieldTemplatesCreateApiResponse,
        AppCrmContactFieldTemplatesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-templates/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactFieldTemplate"],
      }),
      appCrmContactFieldTemplatesRetrieve: build.query<
        AppCrmContactFieldTemplatesRetrieveApiResponse,
        AppCrmContactFieldTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-templates/${queryArg}/`,
        }),
        providesTags: ["ContactFieldTemplate"],
      }),
      appCrmContactFieldTemplatesUpdate: build.mutation<
        AppCrmContactFieldTemplatesUpdateApiResponse,
        AppCrmContactFieldTemplatesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-templates/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactFieldTemplateRequest,
        }),
        invalidatesTags: ["ContactFieldTemplate"],
      }),
      appCrmContactFieldTemplatesPartialUpdate: build.mutation<
        AppCrmContactFieldTemplatesPartialUpdateApiResponse,
        AppCrmContactFieldTemplatesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-templates/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContactFieldTemplate,
        }),
        invalidatesTags: ["ContactFieldTemplate"],
      }),
      appCrmContactFieldTemplatesDestroy: build.mutation<
        AppCrmContactFieldTemplatesDestroyApiResponse,
        AppCrmContactFieldTemplatesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-field-templates/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactFieldTemplate"],
      }),
      appCrmContactNotesList: build.query<
        AppCrmContactNotesListApiResponse,
        AppCrmContactNotesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-notes/`,
          params: {
            allowed_users: queryArg.allowedUsers,
            allowed_users_in: queryArg.allowedUsersIn,
            allowed_users_isnull: queryArg.allowedUsersIsnull,
            body: queryArg.body,
            body_contains: queryArg.bodyContains,
            body_endswith: queryArg.bodyEndswith,
            body_icontains: queryArg.bodyIcontains,
            body_iexact: queryArg.bodyIexact,
            body_in: queryArg.bodyIn,
            body_ine: queryArg.bodyIne,
            body_isempty: queryArg.bodyIsempty,
            body_isnull: queryArg.bodyIsnull,
            body_ne: queryArg.bodyNe,
            body_not_contains: queryArg.bodyNotContains,
            body_not_icontains: queryArg.bodyNotIcontains,
            body_startswith: queryArg.bodyStartswith,
            contacts: queryArg.contacts,
            contacts_in: queryArg.contactsIn,
            contacts_isnull: queryArg.contactsIsnull,
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            offset: queryArg.offset,
            order_by: queryArg.orderBy,
            search: queryArg.search,
            search_contains: queryArg.searchContains,
            search_endswith: queryArg.searchEndswith,
            search_icontains: queryArg.searchIcontains,
            search_iexact: queryArg.searchIexact,
            search_in: queryArg.searchIn,
            search_ine: queryArg.searchIne,
            search_isempty: queryArg.searchIsempty,
            search_isnull: queryArg.searchIsnull,
            search_ne: queryArg.searchNe,
            search_not_contains: queryArg.searchNotContains,
            search_not_icontains: queryArg.searchNotIcontains,
            search_startswith: queryArg.searchStartswith,
            teammates: queryArg.teammates,
            teammates_in: queryArg.teammatesIn,
            teammates_isnull: queryArg.teammatesIsnull,
          },
        }),
        providesTags: ["ContactNote"],
      }),
      appCrmContactNotesCreate: build.mutation<
        AppCrmContactNotesCreateApiResponse,
        AppCrmContactNotesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-notes/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactNote"],
      }),
      appCrmContactNotesRetrieve: build.query<
        AppCrmContactNotesRetrieveApiResponse,
        AppCrmContactNotesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-notes/${queryArg}/`,
        }),
        providesTags: ["ContactNote"],
      }),
      appCrmContactNotesUpdate: build.mutation<
        AppCrmContactNotesUpdateApiResponse,
        AppCrmContactNotesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-notes/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactNoteRequest,
        }),
        invalidatesTags: ["ContactNote"],
      }),
      appCrmContactNotesPartialUpdate: build.mutation<
        AppCrmContactNotesPartialUpdateApiResponse,
        AppCrmContactNotesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-notes/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContactNote,
        }),
        invalidatesTags: ["ContactNote"],
      }),
      appCrmContactNotesDestroy: build.mutation<
        AppCrmContactNotesDestroyApiResponse,
        AppCrmContactNotesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-notes/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactNote"],
      }),
      appCrmContactTagsList: build.query<
        AppCrmContactTagsListApiResponse,
        AppCrmContactTagsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tags/`,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            name: queryArg.name,
            name_contains: queryArg.nameContains,
            name_endswith: queryArg.nameEndswith,
            name_icontains: queryArg.nameIcontains,
            name_iexact: queryArg.nameIexact,
            name_in: queryArg.nameIn,
            name_ine: queryArg.nameIne,
            name_isempty: queryArg.nameIsempty,
            name_isnull: queryArg.nameIsnull,
            name_ne: queryArg.nameNe,
            name_not_contains: queryArg.nameNotContains,
            name_not_icontains: queryArg.nameNotIcontains,
            name_startswith: queryArg.nameStartswith,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["Tag"],
      }),
      appCrmContactTagsCreate: build.mutation<
        AppCrmContactTagsCreateApiResponse,
        AppCrmContactTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tags/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Tag"],
      }),
      appCrmContactTagsRetrieve: build.query<
        AppCrmContactTagsRetrieveApiResponse,
        AppCrmContactTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tags/${queryArg}/`,
        }),
        providesTags: ["Tag"],
      }),
      appCrmContactTagsUpdate: build.mutation<
        AppCrmContactTagsUpdateApiResponse,
        AppCrmContactTagsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tags/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.tagRequest,
        }),
        invalidatesTags: ["Tag"],
      }),
      appCrmContactTagsPartialUpdate: build.mutation<
        AppCrmContactTagsPartialUpdateApiResponse,
        AppCrmContactTagsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tags/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedTag,
        }),
        invalidatesTags: ["Tag"],
      }),
      appCrmContactTagsDestroy: build.mutation<
        AppCrmContactTagsDestroyApiResponse,
        AppCrmContactTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tags/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["Tag"],
      }),
      appCrmContactTasksList: build.query<
        AppCrmContactTasksListApiResponse,
        AppCrmContactTasksListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tasks/`,
          params: {
            allowed_users: queryArg.allowedUsers,
            allowed_users_in: queryArg.allowedUsersIn,
            allowed_users_isnull: queryArg.allowedUsersIsnull,
            assignee: queryArg.assignee,
            assignee_in: queryArg.assigneeIn,
            assignee_isnull: queryArg.assigneeIsnull,
            contacts: queryArg.contacts,
            contacts_in: queryArg.contactsIn,
            contacts_isnull: queryArg.contactsIsnull,
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            offset: queryArg.offset,
            order_by: queryArg.orderBy,
            search: queryArg.search,
            search_contains: queryArg.searchContains,
            search_endswith: queryArg.searchEndswith,
            search_icontains: queryArg.searchIcontains,
            search_iexact: queryArg.searchIexact,
            search_in: queryArg.searchIn,
            search_ine: queryArg.searchIne,
            search_isempty: queryArg.searchIsempty,
            search_isnull: queryArg.searchIsnull,
            search_ne: queryArg.searchNe,
            search_not_contains: queryArg.searchNotContains,
            search_not_icontains: queryArg.searchNotIcontains,
            search_startswith: queryArg.searchStartswith,
            status: queryArg.status,
            status_in: queryArg.statusIn,
            status_isnull: queryArg.statusIsnull,
            teammates: queryArg.teammates,
            teammates_in: queryArg.teammatesIn,
            teammates_isnull: queryArg.teammatesIsnull,
            title: queryArg.title,
            title_contains: queryArg.titleContains,
            title_endswith: queryArg.titleEndswith,
            title_icontains: queryArg.titleIcontains,
            title_iexact: queryArg.titleIexact,
            title_in: queryArg.titleIn,
            title_ine: queryArg.titleIne,
            title_isempty: queryArg.titleIsempty,
            title_isnull: queryArg.titleIsnull,
            title_ne: queryArg.titleNe,
            title_not_contains: queryArg.titleNotContains,
            title_not_icontains: queryArg.titleNotIcontains,
            title_startswith: queryArg.titleStartswith,
          },
        }),
        providesTags: ["ContactTask"],
      }),
      appCrmContactTasksCreate: build.mutation<
        AppCrmContactTasksCreateApiResponse,
        AppCrmContactTasksCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tasks/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactTask"],
      }),
      appCrmContactTasksRetrieve: build.query<
        AppCrmContactTasksRetrieveApiResponse,
        AppCrmContactTasksRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tasks/${queryArg}/`,
        }),
        providesTags: ["ContactTask"],
      }),
      appCrmContactTasksUpdate: build.mutation<
        AppCrmContactTasksUpdateApiResponse,
        AppCrmContactTasksUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tasks/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactTaskRequest,
        }),
        invalidatesTags: ["ContactTask"],
      }),
      appCrmContactTasksPartialUpdate: build.mutation<
        AppCrmContactTasksPartialUpdateApiResponse,
        AppCrmContactTasksPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tasks/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContactTask,
        }),
        invalidatesTags: ["ContactTask"],
      }),
      appCrmContactTasksDestroy: build.mutation<
        AppCrmContactTasksDestroyApiResponse,
        AppCrmContactTasksDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-tasks/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactTask"],
      }),
      appCrmContactTypesList: build.query<
        AppCrmContactTypesListApiResponse,
        AppCrmContactTypesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-types/`,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            name: queryArg.name,
            name_contains: queryArg.nameContains,
            name_endswith: queryArg.nameEndswith,
            name_icontains: queryArg.nameIcontains,
            name_iexact: queryArg.nameIexact,
            name_in: queryArg.nameIn,
            name_ine: queryArg.nameIne,
            name_isempty: queryArg.nameIsempty,
            name_isnull: queryArg.nameIsnull,
            name_ne: queryArg.nameNe,
            name_not_contains: queryArg.nameNotContains,
            name_not_icontains: queryArg.nameNotIcontains,
            name_startswith: queryArg.nameStartswith,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["ContactType"],
      }),
      appCrmContactTypesCreate: build.mutation<
        AppCrmContactTypesCreateApiResponse,
        AppCrmContactTypesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-types/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["ContactType"],
      }),
      appCrmContactTypesRetrieve: build.query<
        AppCrmContactTypesRetrieveApiResponse,
        AppCrmContactTypesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-types/${queryArg}/`,
        }),
        providesTags: ["ContactType"],
      }),
      appCrmContactTypesUpdate: build.mutation<
        AppCrmContactTypesUpdateApiResponse,
        AppCrmContactTypesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-types/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactTypeRequest,
        }),
        invalidatesTags: ["ContactType"],
      }),
      appCrmContactTypesPartialUpdate: build.mutation<
        AppCrmContactTypesPartialUpdateApiResponse,
        AppCrmContactTypesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-types/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContactType,
        }),
        invalidatesTags: ["ContactType"],
      }),
      appCrmContactTypesDestroy: build.mutation<
        AppCrmContactTypesDestroyApiResponse,
        AppCrmContactTypesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contact-types/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["ContactType"],
      }),
      appCrmContactsList: build.query<
        AppCrmContactsListApiResponse,
        AppCrmContactsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contacts/`,
          params: {
            all_emails: queryArg.allEmails,
            all_emails_contains: queryArg.allEmailsContains,
            all_emails_overlap: queryArg.allEmailsOverlap,
            company: queryArg.company,
            company_in: queryArg.companyIn,
            company_isnull: queryArg.companyIsnull,
            contact_field_template: queryArg.contactFieldTemplate,
            contact_field_template_in: queryArg.contactFieldTemplateIn,
            contact_field_template_isnull: queryArg.contactFieldTemplateIsnull,
            contact_type: queryArg.contactType,
            contact_type_in: queryArg.contactTypeIn,
            contact_type_isnull: queryArg.contactTypeIsnull,
            created_at: queryArg.createdAt,
            created_at_gt: queryArg.createdAtGt,
            created_at_gte: queryArg.createdAtGte,
            created_at_in: queryArg.createdAtIn,
            created_at_isnull: queryArg.createdAtIsnull,
            created_at_lt: queryArg.createdAtLt,
            created_at_lte: queryArg.createdAtLte,
            field_value: queryArg.fieldValue,
            field_value_contains: queryArg.fieldValueContains,
            field_value_endswith: queryArg.fieldValueEndswith,
            field_value_gt: queryArg.fieldValueGt,
            field_value_gte: queryArg.fieldValueGte,
            field_value_icontains: queryArg.fieldValueIcontains,
            field_value_iexact: queryArg.fieldValueIexact,
            field_value_in: queryArg.fieldValueIn,
            field_value_ine: queryArg.fieldValueIne,
            field_value_isempty: queryArg.fieldValueIsempty,
            field_value_isnull: queryArg.fieldValueIsnull,
            field_value_lt: queryArg.fieldValueLt,
            field_value_lte: queryArg.fieldValueLte,
            field_value_ne: queryArg.fieldValueNe,
            field_value_not_contains: queryArg.fieldValueNotContains,
            field_value_not_icontains: queryArg.fieldValueNotIcontains,
            field_value_startswith: queryArg.fieldValueStartswith,
            hidden_date: queryArg.hiddenDate,
            hidden_date_gt: queryArg.hiddenDateGt,
            hidden_date_gte: queryArg.hiddenDateGte,
            hidden_date_in: queryArg.hiddenDateIn,
            hidden_date_isnull: queryArg.hiddenDateIsnull,
            hidden_date_lt: queryArg.hiddenDateLt,
            hidden_date_lte: queryArg.hiddenDateLte,
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            is_resource: queryArg.isResource,
            is_resource_in: queryArg.isResourceIn,
            is_resource_isnull: queryArg.isResourceIsnull,
            limit: queryArg.limit,
            name: queryArg.name,
            name_contains: queryArg.nameContains,
            name_endswith: queryArg.nameEndswith,
            name_icontains: queryArg.nameIcontains,
            name_iexact: queryArg.nameIexact,
            name_in: queryArg.nameIn,
            name_ine: queryArg.nameIne,
            name_isempty: queryArg.nameIsempty,
            name_isnull: queryArg.nameIsnull,
            name_ne: queryArg.nameNe,
            name_not_contains: queryArg.nameNotContains,
            name_not_icontains: queryArg.nameNotIcontains,
            name_startswith: queryArg.nameStartswith,
            offset: queryArg.offset,
            order_by: queryArg.orderBy,
            primary_email: queryArg.primaryEmail,
            primary_email_contains: queryArg.primaryEmailContains,
            primary_email_endswith: queryArg.primaryEmailEndswith,
            primary_email_icontains: queryArg.primaryEmailIcontains,
            primary_email_iexact: queryArg.primaryEmailIexact,
            primary_email_in: queryArg.primaryEmailIn,
            primary_email_ine: queryArg.primaryEmailIne,
            primary_email_isempty: queryArg.primaryEmailIsempty,
            primary_email_isnull: queryArg.primaryEmailIsnull,
            primary_email_ne: queryArg.primaryEmailNe,
            primary_email_not_contains: queryArg.primaryEmailNotContains,
            primary_email_not_icontains: queryArg.primaryEmailNotIcontains,
            primary_email_startswith: queryArg.primaryEmailStartswith,
            search: queryArg.search,
            search_contains: queryArg.searchContains,
            search_endswith: queryArg.searchEndswith,
            search_icontains: queryArg.searchIcontains,
            search_iexact: queryArg.searchIexact,
            search_in: queryArg.searchIn,
            search_ine: queryArg.searchIne,
            search_isempty: queryArg.searchIsempty,
            search_isnull: queryArg.searchIsnull,
            search_ne: queryArg.searchNe,
            search_not_contains: queryArg.searchNotContains,
            search_not_icontains: queryArg.searchNotIcontains,
            search_startswith: queryArg.searchStartswith,
            tags: queryArg.tags,
            tags_in: queryArg.tagsIn,
            tags_isnull: queryArg.tagsIsnull,
            title: queryArg.title,
            title_contains: queryArg.titleContains,
            title_endswith: queryArg.titleEndswith,
            title_icontains: queryArg.titleIcontains,
            title_iexact: queryArg.titleIexact,
            title_in: queryArg.titleIn,
            title_ine: queryArg.titleIne,
            title_isempty: queryArg.titleIsempty,
            title_isnull: queryArg.titleIsnull,
            title_ne: queryArg.titleNe,
            title_not_contains: queryArg.titleNotContains,
            title_not_icontains: queryArg.titleNotIcontains,
            title_startswith: queryArg.titleStartswith,
            updated_at: queryArg.updatedAt,
            updated_at_gt: queryArg.updatedAtGt,
            updated_at_gte: queryArg.updatedAtGte,
            updated_at_in: queryArg.updatedAtIn,
            updated_at_isnull: queryArg.updatedAtIsnull,
            updated_at_lt: queryArg.updatedAtLt,
            updated_at_lte: queryArg.updatedAtLte,
          },
        }),
        providesTags: ["Contact"],
      }),
      appCrmContactsCreate: build.mutation<
        AppCrmContactsCreateApiResponse,
        AppCrmContactsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contacts/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Contact"],
      }),
      appCrmContactsRetrieve: build.query<
        AppCrmContactsRetrieveApiResponse,
        AppCrmContactsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contacts/${queryArg}/`,
        }),
        providesTags: ["Contact"],
      }),
      appCrmContactsUpdate: build.mutation<
        AppCrmContactsUpdateApiResponse,
        AppCrmContactsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contacts/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.contactRequest,
        }),
        invalidatesTags: ["Contact"],
      }),
      appCrmContactsPartialUpdate: build.mutation<
        AppCrmContactsPartialUpdateApiResponse,
        AppCrmContactsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contacts/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedContact,
        }),
        invalidatesTags: ["Contact"],
      }),
      appCrmContactsDestroy: build.mutation<
        AppCrmContactsDestroyApiResponse,
        AppCrmContactsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contacts/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["Contact"],
      }),
      appCrmContactsMergeCreate: build.mutation<
        AppCrmContactsMergeCreateApiResponse,
        AppCrmContactsMergeCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/contacts/merge/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["Contact"],
      }),
      appCrmEventBriefsList: build.query<
        AppCrmEventBriefsListApiResponse,
        AppCrmEventBriefsListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-crm/event-briefs/` }),
        providesTags: ["EventBrief"],
      }),
      appCrmEventBriefsCreate: build.mutation<
        AppCrmEventBriefsCreateApiResponse,
        AppCrmEventBriefsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["EventBrief"],
      }),
      appCrmEventBriefsExternalList: build.query<
        AppCrmEventBriefsExternalListApiResponse,
        AppCrmEventBriefsExternalListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-crm/event-briefs-external/` }),
        providesTags: ["EventBriefExternal"],
      }),
      appCrmEventBriefsExternalCreate: build.mutation<
        AppCrmEventBriefsExternalCreateApiResponse,
        AppCrmEventBriefsExternalCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs-external/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["EventBriefExternal"],
      }),
      appCrmEventBriefsExternalRetrieve: build.query<
        AppCrmEventBriefsExternalRetrieveApiResponse,
        AppCrmEventBriefsExternalRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs-external/${queryArg}/`,
        }),
        providesTags: ["EventBriefExternal"],
      }),
      appCrmEventBriefsExternalUpdate: build.mutation<
        AppCrmEventBriefsExternalUpdateApiResponse,
        AppCrmEventBriefsExternalUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs-external/${queryArg.urlKey}/`,
          method: "PUT",
          body: queryArg.eventBriefExternalRequest,
        }),
        invalidatesTags: ["EventBriefExternal"],
      }),
      appCrmEventBriefsExternalPartialUpdate: build.mutation<
        AppCrmEventBriefsExternalPartialUpdateApiResponse,
        AppCrmEventBriefsExternalPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs-external/${queryArg.urlKey}/`,
          method: "PATCH",
          body: queryArg.patchedEventBriefExternal,
        }),
        invalidatesTags: ["EventBriefExternal"],
      }),
      appCrmEventBriefsExternalDestroy: build.mutation<
        AppCrmEventBriefsExternalDestroyApiResponse,
        AppCrmEventBriefsExternalDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs-external/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["EventBriefExternal"],
      }),
      appCrmEventBriefsRetrieve: build.query<
        AppCrmEventBriefsRetrieveApiResponse,
        AppCrmEventBriefsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs/${queryArg}/`,
        }),
        providesTags: ["EventBrief"],
      }),
      appCrmEventBriefsUpdate: build.mutation<
        AppCrmEventBriefsUpdateApiResponse,
        AppCrmEventBriefsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs/${queryArg.eventUniqueId}/`,
          method: "PUT",
          body: queryArg.eventBriefRequest,
        }),
        invalidatesTags: ["EventBrief"],
      }),
      appCrmEventBriefsPartialUpdate: build.mutation<
        AppCrmEventBriefsPartialUpdateApiResponse,
        AppCrmEventBriefsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs/${queryArg.eventUniqueId}/`,
          method: "PATCH",
          body: queryArg.patchedEventBrief,
        }),
        invalidatesTags: ["EventBrief"],
      }),
      appCrmEventBriefsDestroy: build.mutation<
        AppCrmEventBriefsDestroyApiResponse,
        AppCrmEventBriefsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/event-briefs/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["EventBrief"],
      }),
      appCrmLeaderRelationshipsList: build.query<
        AppCrmLeaderRelationshipsListApiResponse,
        AppCrmLeaderRelationshipsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/leader-relationships/`,
          params: {
            all_emails: queryArg.allEmails,
            all_emails_contains: queryArg.allEmailsContains,
            all_emails_overlap: queryArg.allEmailsOverlap,
            company: queryArg.company,
            company_in: queryArg.companyIn,
            company_isnull: queryArg.companyIsnull,
            contact: queryArg.contact,
            contact_cadence: queryArg.contactCadence,
            contact_cadence_contains: queryArg.contactCadenceContains,
            contact_cadence_endswith: queryArg.contactCadenceEndswith,
            contact_cadence_icontains: queryArg.contactCadenceIcontains,
            contact_cadence_iexact: queryArg.contactCadenceIexact,
            contact_cadence_in: queryArg.contactCadenceIn,
            contact_cadence_ine: queryArg.contactCadenceIne,
            contact_cadence_isempty: queryArg.contactCadenceIsempty,
            contact_cadence_isnull: queryArg.contactCadenceIsnull,
            contact_cadence_ne: queryArg.contactCadenceNe,
            contact_cadence_not_contains: queryArg.contactCadenceNotContains,
            contact_cadence_not_icontains: queryArg.contactCadenceNotIcontains,
            contact_cadence_startswith: queryArg.contactCadenceStartswith,
            contact_cadence_status: queryArg.contactCadenceStatus,
            contact_cadence_status_contains:
              queryArg.contactCadenceStatusContains,
            contact_cadence_status_endswith:
              queryArg.contactCadenceStatusEndswith,
            contact_cadence_status_icontains:
              queryArg.contactCadenceStatusIcontains,
            contact_cadence_status_iexact: queryArg.contactCadenceStatusIexact,
            contact_cadence_status_in: queryArg.contactCadenceStatusIn,
            contact_cadence_status_ine: queryArg.contactCadenceStatusIne,
            contact_cadence_status_isempty:
              queryArg.contactCadenceStatusIsempty,
            contact_cadence_status_isnull: queryArg.contactCadenceStatusIsnull,
            contact_cadence_status_ne: queryArg.contactCadenceStatusNe,
            contact_cadence_status_not_contains:
              queryArg.contactCadenceStatusNotContains,
            contact_cadence_status_not_icontains:
              queryArg.contactCadenceStatusNotIcontains,
            contact_cadence_status_startswith:
              queryArg.contactCadenceStatusStartswith,
            contact_created_at: queryArg.contactCreatedAt,
            contact_created_at_gt: queryArg.contactCreatedAtGt,
            contact_created_at_gte: queryArg.contactCreatedAtGte,
            contact_created_at_in: queryArg.contactCreatedAtIn,
            contact_created_at_isnull: queryArg.contactCreatedAtIsnull,
            contact_created_at_lt: queryArg.contactCreatedAtLt,
            contact_created_at_lte: queryArg.contactCreatedAtLte,
            contact_hidden_date: queryArg.contactHiddenDate,
            contact_hidden_date_gt: queryArg.contactHiddenDateGt,
            contact_hidden_date_gte: queryArg.contactHiddenDateGte,
            contact_hidden_date_in: queryArg.contactHiddenDateIn,
            contact_hidden_date_isnull: queryArg.contactHiddenDateIsnull,
            contact_hidden_date_lt: queryArg.contactHiddenDateLt,
            contact_hidden_date_lte: queryArg.contactHiddenDateLte,
            contact_in: queryArg.contactIn,
            contact_isnull: queryArg.contactIsnull,
            contact_tags: queryArg.contactTags,
            contact_tags_in: queryArg.contactTagsIn,
            contact_tags_isnull: queryArg.contactTagsIsnull,
            contact_type: queryArg.contactType,
            contact_type_in: queryArg.contactTypeIn,
            contact_type_isnull: queryArg.contactTypeIsnull,
            contact_updated_at: queryArg.contactUpdatedAt,
            contact_updated_at_gt: queryArg.contactUpdatedAtGt,
            contact_updated_at_gte: queryArg.contactUpdatedAtGte,
            contact_updated_at_in: queryArg.contactUpdatedAtIn,
            contact_updated_at_isnull: queryArg.contactUpdatedAtIsnull,
            contact_updated_at_lt: queryArg.contactUpdatedAtLt,
            contact_updated_at_lte: queryArg.contactUpdatedAtLte,
            created_at: queryArg.createdAt,
            created_at_gt: queryArg.createdAtGt,
            created_at_gte: queryArg.createdAtGte,
            created_at_in: queryArg.createdAtIn,
            created_at_isnull: queryArg.createdAtIsnull,
            created_at_lt: queryArg.createdAtLt,
            created_at_lte: queryArg.createdAtLte,
            field_template: queryArg.fieldTemplate,
            field_template_in: queryArg.fieldTemplateIn,
            field_template_isnull: queryArg.fieldTemplateIsnull,
            field_value: queryArg.fieldValue,
            field_value_contains: queryArg.fieldValueContains,
            field_value_endswith: queryArg.fieldValueEndswith,
            field_value_gt: queryArg.fieldValueGt,
            field_value_gte: queryArg.fieldValueGte,
            field_value_icontains: queryArg.fieldValueIcontains,
            field_value_iexact: queryArg.fieldValueIexact,
            field_value_in: queryArg.fieldValueIn,
            field_value_ine: queryArg.fieldValueIne,
            field_value_isempty: queryArg.fieldValueIsempty,
            field_value_isnull: queryArg.fieldValueIsnull,
            field_value_lt: queryArg.fieldValueLt,
            field_value_lte: queryArg.fieldValueLte,
            field_value_ne: queryArg.fieldValueNe,
            field_value_not_contains: queryArg.fieldValueNotContains,
            field_value_not_icontains: queryArg.fieldValueNotIcontains,
            field_value_startswith: queryArg.fieldValueStartswith,
            hidden_date: queryArg.hiddenDate,
            hidden_date_gt: queryArg.hiddenDateGt,
            hidden_date_gte: queryArg.hiddenDateGte,
            hidden_date_in: queryArg.hiddenDateIn,
            hidden_date_isnull: queryArg.hiddenDateIsnull,
            hidden_date_lt: queryArg.hiddenDateLt,
            hidden_date_lte: queryArg.hiddenDateLte,
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            leader: queryArg.leader,
            leader_in: queryArg.leaderIn,
            leader_isnull: queryArg.leaderIsnull,
            limit: queryArg.limit,
            name: queryArg.name,
            name_contains: queryArg.nameContains,
            name_endswith: queryArg.nameEndswith,
            name_icontains: queryArg.nameIcontains,
            name_iexact: queryArg.nameIexact,
            name_in: queryArg.nameIn,
            name_ine: queryArg.nameIne,
            name_isempty: queryArg.nameIsempty,
            name_isnull: queryArg.nameIsnull,
            name_ne: queryArg.nameNe,
            name_not_contains: queryArg.nameNotContains,
            name_not_icontains: queryArg.nameNotIcontains,
            name_startswith: queryArg.nameStartswith,
            next_meeting_data_start: queryArg.nextMeetingDataStart,
            next_meeting_data_start_gt: queryArg.nextMeetingDataStartGt,
            next_meeting_data_start_gte: queryArg.nextMeetingDataStartGte,
            next_meeting_data_start_in: queryArg.nextMeetingDataStartIn,
            next_meeting_data_start_isnull: queryArg.nextMeetingDataStartIsnull,
            next_meeting_data_start_lt: queryArg.nextMeetingDataStartLt,
            next_meeting_data_start_lte: queryArg.nextMeetingDataStartLte,
            offset: queryArg.offset,
            order_by: queryArg.orderBy,
            prev_meeting_data_start: queryArg.prevMeetingDataStart,
            prev_meeting_data_start_gt: queryArg.prevMeetingDataStartGt,
            prev_meeting_data_start_gte: queryArg.prevMeetingDataStartGte,
            prev_meeting_data_start_in: queryArg.prevMeetingDataStartIn,
            prev_meeting_data_start_isnull: queryArg.prevMeetingDataStartIsnull,
            prev_meeting_data_start_lt: queryArg.prevMeetingDataStartLt,
            prev_meeting_data_start_lte: queryArg.prevMeetingDataStartLte,
            primary_email: queryArg.primaryEmail,
            primary_email_contains: queryArg.primaryEmailContains,
            primary_email_endswith: queryArg.primaryEmailEndswith,
            primary_email_icontains: queryArg.primaryEmailIcontains,
            primary_email_iexact: queryArg.primaryEmailIexact,
            primary_email_in: queryArg.primaryEmailIn,
            primary_email_ine: queryArg.primaryEmailIne,
            primary_email_isempty: queryArg.primaryEmailIsempty,
            primary_email_isnull: queryArg.primaryEmailIsnull,
            primary_email_ne: queryArg.primaryEmailNe,
            primary_email_not_contains: queryArg.primaryEmailNotContains,
            primary_email_not_icontains: queryArg.primaryEmailNotIcontains,
            primary_email_startswith: queryArg.primaryEmailStartswith,
            relationship_strength: queryArg.relationshipStrength,
            relationship_strength_auto: queryArg.relationshipStrengthAuto,
            relationship_strength_auto_gt: queryArg.relationshipStrengthAutoGt,
            relationship_strength_auto_gte:
              queryArg.relationshipStrengthAutoGte,
            relationship_strength_auto_in: queryArg.relationshipStrengthAutoIn,
            relationship_strength_auto_isnull:
              queryArg.relationshipStrengthAutoIsnull,
            relationship_strength_auto_lt: queryArg.relationshipStrengthAutoLt,
            relationship_strength_auto_lte:
              queryArg.relationshipStrengthAutoLte,
            relationship_strength_in: queryArg.relationshipStrengthIn,
            relationship_strength_isnull: queryArg.relationshipStrengthIsnull,
            relationship_strength_override:
              queryArg.relationshipStrengthOverride,
            relationship_strength_override_in:
              queryArg.relationshipStrengthOverrideIn,
            relationship_strength_override_isnull:
              queryArg.relationshipStrengthOverrideIsnull,
            relationship_type: queryArg.relationshipType,
            relationship_type_in: queryArg.relationshipTypeIn,
            relationship_type_isnull: queryArg.relationshipTypeIsnull,
            source: queryArg.source,
            source_in: queryArg.sourceIn,
            source_isnull: queryArg.sourceIsnull,
            tags: queryArg.tags,
            tags_in: queryArg.tagsIn,
            tags_isnull: queryArg.tagsIsnull,
            title: queryArg.title,
            title_contains: queryArg.titleContains,
            title_endswith: queryArg.titleEndswith,
            title_icontains: queryArg.titleIcontains,
            title_iexact: queryArg.titleIexact,
            title_in: queryArg.titleIn,
            title_ine: queryArg.titleIne,
            title_isempty: queryArg.titleIsempty,
            title_isnull: queryArg.titleIsnull,
            title_ne: queryArg.titleNe,
            title_not_contains: queryArg.titleNotContains,
            title_not_icontains: queryArg.titleNotIcontains,
            title_startswith: queryArg.titleStartswith,
            updated_at: queryArg.updatedAt,
            updated_at_gt: queryArg.updatedAtGt,
            updated_at_gte: queryArg.updatedAtGte,
            updated_at_in: queryArg.updatedAtIn,
            updated_at_isnull: queryArg.updatedAtIsnull,
            updated_at_lt: queryArg.updatedAtLt,
            updated_at_lte: queryArg.updatedAtLte,
          },
        }),
        providesTags: ["LeaderRelationship", "Contact", "ContactCadence"],
      }),
      appCrmLeaderRelationshipsCreate: build.mutation<
        AppCrmLeaderRelationshipsCreateApiResponse,
        AppCrmLeaderRelationshipsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/leader-relationships/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["LeaderRelationship", "Contact", "ContactCadence"],
      }),
      appCrmLeaderRelationshipsRetrieve: build.query<
        AppCrmLeaderRelationshipsRetrieveApiResponse,
        AppCrmLeaderRelationshipsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/leader-relationships/${queryArg}/`,
        }),
        providesTags: ["LeaderRelationship", "Contact", "ContactCadence"],
      }),
      appCrmLeaderRelationshipsUpdate: build.mutation<
        AppCrmLeaderRelationshipsUpdateApiResponse,
        AppCrmLeaderRelationshipsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/leader-relationships/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.leaderRelationshipRequest,
        }),
        invalidatesTags: ["LeaderRelationship", "Contact", "ContactCadence"],
      }),
      appCrmLeaderRelationshipsPartialUpdate: build.mutation<
        AppCrmLeaderRelationshipsPartialUpdateApiResponse,
        AppCrmLeaderRelationshipsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/leader-relationships/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedLeaderRelationship,
        }),
        invalidatesTags: ["LeaderRelationship", "Contact", "ContactCadence"],
      }),
      appCrmLeaderRelationshipsDestroy: build.mutation<
        AppCrmLeaderRelationshipsDestroyApiResponse,
        AppCrmLeaderRelationshipsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/leader-relationships/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["LeaderRelationship", "Contact", "ContactCadence"],
      }),
      appCrmPreferencesList: build.query<
        AppCrmPreferencesListApiResponse,
        AppCrmPreferencesListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-crm/preferences/` }),
        providesTags: ["CrmPreferences"],
      }),
      appCrmPreferencesCreate: build.mutation<
        AppCrmPreferencesCreateApiResponse,
        AppCrmPreferencesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/preferences/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["CrmPreferences"],
      }),
      appCrmPreferencesRetrieve: build.query<
        AppCrmPreferencesRetrieveApiResponse,
        AppCrmPreferencesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/preferences/${queryArg}/`,
        }),
        providesTags: ["CrmPreferences"],
      }),
      appCrmPreferencesUpdate: build.mutation<
        AppCrmPreferencesUpdateApiResponse,
        AppCrmPreferencesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/preferences/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.crmPreferencesRequest,
        }),
        invalidatesTags: ["CrmPreferences"],
      }),
      appCrmPreferencesPartialUpdate: build.mutation<
        AppCrmPreferencesPartialUpdateApiResponse,
        AppCrmPreferencesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/preferences/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedCrmPreferences,
        }),
        invalidatesTags: ["CrmPreferences"],
      }),
      appCrmPreferencesDestroy: build.mutation<
        AppCrmPreferencesDestroyApiResponse,
        AppCrmPreferencesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/preferences/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["CrmPreferences"],
      }),
      appCrmPrivateContactsList: build.query<
        AppCrmPrivateContactsListApiResponse,
        AppCrmPrivateContactsListApiArg
      >({
        query: () => ({ url: `/api/v1_15/app-crm/private-contacts/` }),
        providesTags: ["LeaderPrivateContact"],
      }),
      appCrmPrivateContactsAddPrivateContactCreate: build.mutation<
        AppCrmPrivateContactsAddPrivateContactCreateApiResponse,
        AppCrmPrivateContactsAddPrivateContactCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/private-contacts/${queryArg.id}/add-private-contact/`,
          method: "POST",
          body: queryArg.addRemovePrivateContactInputRequest,
        }),
        invalidatesTags: ["LeaderPrivateContact"],
      }),
      appCrmPrivateContactsRemovePrivateContactCreate: build.mutation<
        AppCrmPrivateContactsRemovePrivateContactCreateApiResponse,
        AppCrmPrivateContactsRemovePrivateContactCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/private-contacts/${queryArg.id}/remove-private-contact/`,
          method: "POST",
          body: queryArg.addRemovePrivateContactInputRequest,
        }),
        invalidatesTags: ["LeaderPrivateContact"],
      }),
      appCrmRelationshipTagsList: build.query<
        AppCrmRelationshipTagsListApiResponse,
        AppCrmRelationshipTagsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/relationship-tags/`,
          params: {
            id: queryArg.id,
            id_gt: queryArg.idGt,
            id_gte: queryArg.idGte,
            id_in: queryArg.idIn,
            id_isnull: queryArg.idIsnull,
            id_lt: queryArg.idLt,
            id_lte: queryArg.idLte,
            limit: queryArg.limit,
            name: queryArg.name,
            name_contains: queryArg.nameContains,
            name_endswith: queryArg.nameEndswith,
            name_icontains: queryArg.nameIcontains,
            name_iexact: queryArg.nameIexact,
            name_in: queryArg.nameIn,
            name_ine: queryArg.nameIne,
            name_isempty: queryArg.nameIsempty,
            name_isnull: queryArg.nameIsnull,
            name_ne: queryArg.nameNe,
            name_not_contains: queryArg.nameNotContains,
            name_not_icontains: queryArg.nameNotIcontains,
            name_startswith: queryArg.nameStartswith,
            offset: queryArg.offset,
          },
        }),
        providesTags: ["RelationshipTag"],
      }),
      appCrmRelationshipTagsCreate: build.mutation<
        AppCrmRelationshipTagsCreateApiResponse,
        AppCrmRelationshipTagsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/relationship-tags/`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["RelationshipTag"],
      }),
      appCrmRelationshipTagsRetrieve: build.query<
        AppCrmRelationshipTagsRetrieveApiResponse,
        AppCrmRelationshipTagsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/relationship-tags/${queryArg}/`,
        }),
        providesTags: ["RelationshipTag"],
      }),
      appCrmRelationshipTagsUpdate: build.mutation<
        AppCrmRelationshipTagsUpdateApiResponse,
        AppCrmRelationshipTagsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/relationship-tags/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.relationshipTagRequest,
        }),
        invalidatesTags: ["RelationshipTag"],
      }),
      appCrmRelationshipTagsPartialUpdate: build.mutation<
        AppCrmRelationshipTagsPartialUpdateApiResponse,
        AppCrmRelationshipTagsPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/relationship-tags/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedRelationshipTag,
        }),
        invalidatesTags: ["RelationshipTag"],
      }),
      appCrmRelationshipTagsDestroy: build.mutation<
        AppCrmRelationshipTagsDestroyApiResponse,
        AppCrmRelationshipTagsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/v1_15/app-crm/relationship-tags/${queryArg}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["RelationshipTag"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as crmGenerated };
export type AppCrmCompaniesListApiResponse =
  /** status 200  */ PaginatedCompanyList;
export type AppCrmCompaniesListApiArg = {
  hiddenDate?: string;
  /** hidden_date (greater than) */
  hiddenDateGt?: string;
  /** hidden_date (greater than or equal to) */
  hiddenDateGte?: string;
  /** hidden_date (in) */
  hiddenDateIn?: string;
  /** hidden_date (is null) */
  hiddenDateIsnull?: boolean;
  /** hidden_date (less than) */
  hiddenDateLt?: string;
  /** hidden_date (less than or equal to) */
  hiddenDateLte?: string;
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** name (contains) */
  nameContains?: string;
  /** name (endswith) */
  nameEndswith?: string;
  /** name (icontains) */
  nameIcontains?: string;
  /** name (equals, case-insensitive) */
  nameIexact?: string;
  /** name (in) */
  nameIn?: string;
  /** name (not equals, case-insensitive) */
  nameIne?: any;
  /** name (is empty or null) */
  nameIsempty?: any;
  /** name (is null) */
  nameIsnull?: boolean;
  /** name (not equals) */
  nameNe?: any;
  /** name (not contains) */
  nameNotContains?: any;
  /** name (not icontains) */
  nameNotIcontains?: any;
  /** name (startswith) */
  nameStartswith?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering
    
    * `id` - Id
    * `-id` - Id (descending)
    * `name` - Name
    * `-name` - Name (descending)
    * `category` - Category
    * `-category` - Category (descending) */
  orderBy?: ("-category" | "-id" | "-name" | "category" | "id" | "name")[];
  search?: string;
  /** search (contains) */
  searchContains?: string;
  /** search (endswith) */
  searchEndswith?: string;
  /** search (icontains) */
  searchIcontains?: string;
  /** search (equals, case-insensitive) */
  searchIexact?: string;
  /** search (in) */
  searchIn?: string;
  /** search (not equals, case-insensitive) */
  searchIne?: any;
  /** search (is empty or null) */
  searchIsempty?: any;
  /** search (is null) */
  searchIsnull?: string;
  /** search (not equals) */
  searchNe?: any;
  /** search (not contains) */
  searchNotContains?: any;
  /** search (not icontains) */
  searchNotIcontains?: any;
  /** search (startswith) */
  searchStartswith?: string;
};
export type AppCrmCompaniesCreateApiResponse = /** status 201  */ Company;
export type AppCrmCompaniesCreateApiArg = CompanyRequest;
export type AppCrmCompaniesRetrieveApiResponse = /** status 200  */ Company;
export type AppCrmCompaniesRetrieveApiArg =
  /** A unique integer value identifying this company. */ number;
export type AppCrmCompaniesUpdateApiResponse = /** status 200  */ Company;
export type AppCrmCompaniesUpdateApiArg = {
  /** A unique integer value identifying this company. */
  id: number;
  companyRequest: CompanyRequest;
};
export type AppCrmCompaniesPartialUpdateApiResponse =
  /** status 200  */ Company;
export type AppCrmCompaniesPartialUpdateApiArg = {
  /** A unique integer value identifying this company. */
  id: number;
  patchedCompany: PatchedCompany;
};
export type AppCrmCompaniesDestroyApiResponse = unknown;
export type AppCrmCompaniesDestroyApiArg =
  /** A unique integer value identifying this company. */ number;
export type AppCrmCompanyCategoriesListApiResponse =
  /** status 200  */ PaginatedCompanyCategoryList;
export type AppCrmCompanyCategoriesListApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** name (contains) */
  nameContains?: string;
  /** name (endswith) */
  nameEndswith?: string;
  /** name (icontains) */
  nameIcontains?: string;
  /** name (equals, case-insensitive) */
  nameIexact?: string;
  /** name (in) */
  nameIn?: string;
  /** name (not equals, case-insensitive) */
  nameIne?: any;
  /** name (is empty or null) */
  nameIsempty?: any;
  /** name (is null) */
  nameIsnull?: boolean;
  /** name (not equals) */
  nameNe?: any;
  /** name (not contains) */
  nameNotContains?: any;
  /** name (not icontains) */
  nameNotIcontains?: any;
  /** name (startswith) */
  nameStartswith?: string;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCrmCompanyCategoriesCreateApiResponse =
  /** status 201  */ CompanyCategory;
export type AppCrmCompanyCategoriesCreateApiArg = CompanyCategoryRequest;
export type AppCrmCompanyCategoriesRetrieveApiResponse =
  /** status 200  */ CompanyCategory;
export type AppCrmCompanyCategoriesRetrieveApiArg =
  /** A unique integer value identifying this company category. */ number;
export type AppCrmCompanyCategoriesUpdateApiResponse =
  /** status 200  */ CompanyCategory;
export type AppCrmCompanyCategoriesUpdateApiArg = {
  /** A unique integer value identifying this company category. */
  id: number;
  companyCategoryRequest: CompanyCategoryRequest;
};
export type AppCrmCompanyCategoriesPartialUpdateApiResponse =
  /** status 200  */ CompanyCategory;
export type AppCrmCompanyCategoriesPartialUpdateApiArg = {
  /** A unique integer value identifying this company category. */
  id: number;
  patchedCompanyCategory: PatchedCompanyCategory;
};
export type AppCrmCompanyCategoriesDestroyApiResponse = unknown;
export type AppCrmCompanyCategoriesDestroyApiArg =
  /** A unique integer value identifying this company category. */ number;
export type AppCrmContactCadenceListApiResponse =
  /** status 200  */ PaginatedContactCadenceList;
export type AppCrmContactCadenceListApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCrmContactCadenceCreateApiResponse =
  /** status 201  */ ContactCadence;
export type AppCrmContactCadenceCreateApiArg = ContactCadenceRequest;
export type AppCrmContactCadenceRetrieveApiResponse =
  /** status 200  */ ContactCadence;
export type AppCrmContactCadenceRetrieveApiArg =
  /** A unique integer value identifying this contact cadence. */ number;
export type AppCrmContactCadenceUpdateApiResponse =
  /** status 200  */ ContactCadence;
export type AppCrmContactCadenceUpdateApiArg = {
  /** A unique integer value identifying this contact cadence. */
  id: number;
  contactCadenceRequest: ContactCadenceRequest;
};
export type AppCrmContactCadencePartialUpdateApiResponse =
  /** status 200  */ ContactCadence;
export type AppCrmContactCadencePartialUpdateApiArg = {
  /** A unique integer value identifying this contact cadence. */
  id: number;
  patchedContactCadence: PatchedContactCadence;
};
export type AppCrmContactCadenceDestroyApiResponse = unknown;
export type AppCrmContactCadenceDestroyApiArg =
  /** A unique integer value identifying this contact cadence. */ number;
export type AppCrmContactCategoriesListApiResponse =
  /** status 200  */ PaginatedTagList;
export type AppCrmContactCategoriesListApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** name (contains) */
  nameContains?: string;
  /** name (endswith) */
  nameEndswith?: string;
  /** name (icontains) */
  nameIcontains?: string;
  /** name (equals, case-insensitive) */
  nameIexact?: string;
  /** name (in) */
  nameIn?: string;
  /** name (not equals, case-insensitive) */
  nameIne?: any;
  /** name (is empty or null) */
  nameIsempty?: any;
  /** name (is null) */
  nameIsnull?: boolean;
  /** name (not equals) */
  nameNe?: any;
  /** name (not contains) */
  nameNotContains?: any;
  /** name (not icontains) */
  nameNotIcontains?: any;
  /** name (startswith) */
  nameStartswith?: string;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCrmContactCategoriesCreateApiResponse = /** status 201  */ Tag;
export type AppCrmContactCategoriesCreateApiArg = TagRequest;
export type AppCrmContactCategoriesRetrieveApiResponse = /** status 200  */ Tag;
export type AppCrmContactCategoriesRetrieveApiArg =
  /** A unique integer value identifying this tag. */ number;
export type AppCrmContactCategoriesUpdateApiResponse = /** status 200  */ Tag;
export type AppCrmContactCategoriesUpdateApiArg = {
  /** A unique integer value identifying this tag. */
  id: number;
  tagRequest: TagRequest;
};
export type AppCrmContactCategoriesPartialUpdateApiResponse =
  /** status 200  */ Tag;
export type AppCrmContactCategoriesPartialUpdateApiArg = {
  /** A unique integer value identifying this tag. */
  id: number;
  patchedTag: PatchedTag;
};
export type AppCrmContactCategoriesDestroyApiResponse = unknown;
export type AppCrmContactCategoriesDestroyApiArg =
  /** A unique integer value identifying this tag. */ number;
export type AppCrmContactEmailsListApiResponse =
  /** status 200  */ PaginatedContactEmailList;
export type AppCrmContactEmailsListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCrmContactEmailsCreateApiResponse =
  /** status 201  */ ContactEmail;
export type AppCrmContactEmailsCreateApiArg = ContactEmailRequest;
export type AppCrmContactEmailsRetrieveApiResponse =
  /** status 200  */ ContactEmail;
export type AppCrmContactEmailsRetrieveApiArg =
  /** A unique integer value identifying this Contact Email. */ number;
export type AppCrmContactEmailsUpdateApiResponse =
  /** status 200  */ ContactEmail;
export type AppCrmContactEmailsUpdateApiArg = {
  /** A unique integer value identifying this Contact Email. */
  id: number;
  contactEmailRequest: ContactEmailRequest;
};
export type AppCrmContactEmailsPartialUpdateApiResponse =
  /** status 200  */ ContactEmail;
export type AppCrmContactEmailsPartialUpdateApiArg = {
  /** A unique integer value identifying this Contact Email. */
  id: number;
  patchedContactEmail: PatchedContactEmail;
};
export type AppCrmContactEmailsDestroyApiResponse = unknown;
export type AppCrmContactEmailsDestroyApiArg =
  /** A unique integer value identifying this Contact Email. */ number;
export type AppCrmContactEventsListApiResponse =
  /** status 200  */ PaginatedContactEventList;
export type AppCrmContactEventsListApiArg = {
  attendees?: number[];
  /** attendees (in) */
  attendeesIn?: string;
  /** attendees (is null) */
  attendeesIsnull?: boolean;
  /** * `event_idr` - event_idr
   * `icaluid` - icaluid
   * `event_unique_id` - event_unique_id */
  distinct?: "event_idr" | "event_unique_id" | "icaluid";
  /** distinct (in) */
  distinctIn?: string;
  /** distinct (is null) */
  distinctIsnull?: string;
  endDate?: string;
  /** end_date (greater than) */
  endDateGt?: string;
  /** end_date (greater than or equal to) */
  endDateGte?: string;
  /** end_date (in) */
  endDateIn?: string;
  /** end_date (is null) */
  endDateIsnull?: boolean;
  /** end_date (less than) */
  endDateLt?: string;
  /** end_date (less than or equal to) */
  endDateLte?: string;
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  leaders?: number[];
  /** leaders (in) */
  leadersIn?: string;
  /** leaders (is null) */
  leadersIsnull?: boolean;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering
    
    * `start_date` - Start date
    * `-start_date` - Start date (descending)
    * `end_date` - End date
    * `-end_date` - End date (descending) */
  orderBy?: ("-end_date" | "-start_date" | "end_date" | "start_date")[];
  startDate?: string;
  /** start_date (greater than) */
  startDateGt?: string;
  /** start_date (greater than or equal to) */
  startDateGte?: string;
  /** start_date (in) */
  startDateIn?: string;
  /** start_date (is null) */
  startDateIsnull?: boolean;
  /** start_date (less than) */
  startDateLt?: string;
  /** start_date (less than or equal to) */
  startDateLte?: string;
  title?: string;
  /** title (contains) */
  titleContains?: string;
  /** title (endswith) */
  titleEndswith?: string;
  /** title (icontains) */
  titleIcontains?: string;
  /** title (equals, case-insensitive) */
  titleIexact?: string;
  /** title (in) */
  titleIn?: string;
  /** title (not equals, case-insensitive) */
  titleIne?: any;
  /** title (is empty or null) */
  titleIsempty?: any;
  /** title (is null) */
  titleIsnull?: boolean;
  /** title (not equals) */
  titleNe?: any;
  /** title (not contains) */
  titleNotContains?: any;
  /** title (not icontains) */
  titleNotIcontains?: any;
  /** title (startswith) */
  titleStartswith?: string;
};
export type AppCrmContactFieldChoicesListApiResponse =
  /** status 200  */ PaginatedContactFieldChoiceList;
export type AppCrmContactFieldChoicesListApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  label?: string;
  /** label (contains) */
  labelContains?: string;
  /** label (endswith) */
  labelEndswith?: string;
  /** label (icontains) */
  labelIcontains?: string;
  /** label (equals, case-insensitive) */
  labelIexact?: string;
  /** label (in) */
  labelIn?: string;
  /** label (not equals, case-insensitive) */
  labelIne?: any;
  /** label (is empty or null) */
  labelIsempty?: any;
  /** label (is null) */
  labelIsnull?: boolean;
  /** label (not equals) */
  labelNe?: any;
  /** label (not contains) */
  labelNotContains?: any;
  /** label (not icontains) */
  labelNotIcontains?: any;
  /** label (startswith) */
  labelStartswith?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCrmContactFieldChoicesCreateApiResponse =
  /** status 201  */ ContactFieldChoice;
export type AppCrmContactFieldChoicesCreateApiArg = ContactFieldChoiceRequest;
export type AppCrmContactFieldChoicesRetrieveApiResponse =
  /** status 200  */ ContactFieldChoice;
export type AppCrmContactFieldChoicesRetrieveApiArg =
  /** A unique integer value identifying this contact field choice. */ number;
export type AppCrmContactFieldChoicesUpdateApiResponse =
  /** status 200  */ ContactFieldChoice;
export type AppCrmContactFieldChoicesUpdateApiArg = {
  /** A unique integer value identifying this contact field choice. */
  id: number;
  contactFieldChoiceRequest: ContactFieldChoiceRequest;
};
export type AppCrmContactFieldChoicesPartialUpdateApiResponse =
  /** status 200  */ ContactFieldChoice;
export type AppCrmContactFieldChoicesPartialUpdateApiArg = {
  /** A unique integer value identifying this contact field choice. */
  id: number;
  patchedContactFieldChoice: PatchedContactFieldChoice;
};
export type AppCrmContactFieldChoicesDestroyApiResponse = unknown;
export type AppCrmContactFieldChoicesDestroyApiArg =
  /** A unique integer value identifying this contact field choice. */ number;
export type AppCrmContactFieldChoicesBulkDeleteCreateApiResponse =
  /** status 200  */ {
    data: number[];
    meta: {
      count?: number;
      next?: string | null;
      previous?: string | null;
      data_map?: object;
    };
  };
export type AppCrmContactFieldChoicesBulkDeleteCreateApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  label?: string;
  /** label (contains) */
  labelContains?: string;
  /** label (endswith) */
  labelEndswith?: string;
  /** label (icontains) */
  labelIcontains?: string;
  /** label (equals, case-insensitive) */
  labelIexact?: string;
  /** label (in) */
  labelIn?: string;
  /** label (not equals, case-insensitive) */
  labelIne?: any;
  /** label (is empty or null) */
  labelIsempty?: any;
  /** label (is null) */
  labelIsnull?: boolean;
  /** label (not equals) */
  labelNe?: any;
  /** label (not contains) */
  labelNotContains?: any;
  /** label (not icontains) */
  labelNotIcontains?: any;
  /** label (startswith) */
  labelStartswith?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  body: number[];
};
export type AppCrmContactFieldChoicesBulkUpsertCreateApiResponse =
  /** status 200  */ PaginatedContactFieldChoiceList;
export type AppCrmContactFieldChoicesBulkUpsertCreateApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  label?: string;
  /** label (contains) */
  labelContains?: string;
  /** label (endswith) */
  labelEndswith?: string;
  /** label (icontains) */
  labelIcontains?: string;
  /** label (equals, case-insensitive) */
  labelIexact?: string;
  /** label (in) */
  labelIn?: string;
  /** label (not equals, case-insensitive) */
  labelIne?: any;
  /** label (is empty or null) */
  labelIsempty?: any;
  /** label (is null) */
  labelIsnull?: boolean;
  /** label (not equals) */
  labelNe?: any;
  /** label (not contains) */
  labelNotContains?: any;
  /** label (not icontains) */
  labelNotIcontains?: any;
  /** label (startswith) */
  labelStartswith?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  body: ContactFieldChoiceRequest[];
};
export type AppCrmContactFieldOrdersListApiResponse =
  /** status 200  */ PaginatedContactFieldOrderList;
export type AppCrmContactFieldOrdersListApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  order?: number;
  /** order (greater than) */
  orderGt?: number;
  /** order (greater than or equal to) */
  orderGte?: number;
  /** order (in) */
  orderIn?: string;
  /** order (is null) */
  orderIsnull?: boolean;
  /** order (less than) */
  orderLt?: number;
  /** order (less than or equal to) */
  orderLte?: number;
};
export type AppCrmContactFieldOrdersCreateApiResponse =
  /** status 201  */ ContactFieldOrder;
export type AppCrmContactFieldOrdersCreateApiArg = ContactFieldOrderRequest;
export type AppCrmContactFieldOrdersRetrieveApiResponse =
  /** status 200  */ ContactFieldOrder;
export type AppCrmContactFieldOrdersRetrieveApiArg =
  /** A unique integer value identifying this contact field order. */ number;
export type AppCrmContactFieldOrdersUpdateApiResponse =
  /** status 200  */ ContactFieldOrder;
export type AppCrmContactFieldOrdersUpdateApiArg = {
  /** A unique integer value identifying this contact field order. */
  id: number;
  contactFieldOrderRequest: ContactFieldOrderRequest;
};
export type AppCrmContactFieldOrdersPartialUpdateApiResponse =
  /** status 200  */ ContactFieldOrder;
export type AppCrmContactFieldOrdersPartialUpdateApiArg = {
  /** A unique integer value identifying this contact field order. */
  id: number;
  patchedContactFieldOrder: PatchedContactFieldOrder;
};
export type AppCrmContactFieldOrdersDestroyApiResponse = unknown;
export type AppCrmContactFieldOrdersDestroyApiArg =
  /** A unique integer value identifying this contact field order. */ number;
export type AppCrmContactFieldTemplatesListApiResponse =
  /** status 200  */ PaginatedContactFieldTemplateList;
export type AppCrmContactFieldTemplatesListApiArg = {
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  valueType?: string;
  /** value_type (contains) */
  valueTypeContains?: string;
  /** value_type (endswith) */
  valueTypeEndswith?: string;
  /** value_type (icontains) */
  valueTypeIcontains?: string;
  /** value_type (equals, case-insensitive) */
  valueTypeIexact?: string;
  /** value_type (in) */
  valueTypeIn?: string;
  /** value_type (not equals, case-insensitive) */
  valueTypeIne?: any;
  /** value_type (is empty or null) */
  valueTypeIsempty?: any;
  /** value_type (is null) */
  valueTypeIsnull?: string;
  /** value_type (not equals) */
  valueTypeNe?: any;
  /** value_type (not contains) */
  valueTypeNotContains?: any;
  /** value_type (not icontains) */
  valueTypeNotIcontains?: any;
  /** value_type (startswith) */
  valueTypeStartswith?: string;
};
export type AppCrmContactFieldTemplatesCreateApiResponse =
  /** status 201  */ ContactFieldTemplate;
export type AppCrmContactFieldTemplatesCreateApiArg =
  ContactFieldTemplateRequest;
export type AppCrmContactFieldTemplatesRetrieveApiResponse =
  /** status 200  */ ContactFieldTemplate;
export type AppCrmContactFieldTemplatesRetrieveApiArg =
  /** A unique integer value identifying this contact field template. */ number;
export type AppCrmContactFieldTemplatesUpdateApiResponse =
  /** status 200  */ ContactFieldTemplate;
export type AppCrmContactFieldTemplatesUpdateApiArg = {
  /** A unique integer value identifying this contact field template. */
  id: number;
  contactFieldTemplateRequest: ContactFieldTemplateRequest;
};
export type AppCrmContactFieldTemplatesPartialUpdateApiResponse =
  /** status 200  */ ContactFieldTemplate;
export type AppCrmContactFieldTemplatesPartialUpdateApiArg = {
  /** A unique integer value identifying this contact field template. */
  id: number;
  patchedContactFieldTemplate: PatchedContactFieldTemplate;
};
export type AppCrmContactFieldTemplatesDestroyApiResponse = unknown;
export type AppCrmContactFieldTemplatesDestroyApiArg =
  /** A unique integer value identifying this contact field template. */ number;
export type AppCrmContactNotesListApiResponse =
  /** status 200  */ PaginatedContactNoteList;
export type AppCrmContactNotesListApiArg = {
  allowedUsers?: number[];
  /** allowed_users (in) */
  allowedUsersIn?: string;
  /** allowed_users (is null) */
  allowedUsersIsnull?: boolean;
  body?: string;
  /** body (contains) */
  bodyContains?: string;
  /** body (endswith) */
  bodyEndswith?: string;
  /** body (icontains) */
  bodyIcontains?: string;
  /** body (equals, case-insensitive) */
  bodyIexact?: string;
  /** body (in) */
  bodyIn?: string;
  /** body (not equals, case-insensitive) */
  bodyIne?: any;
  /** body (is empty or null) */
  bodyIsempty?: any;
  /** body (is null) */
  bodyIsnull?: boolean;
  /** body (not equals) */
  bodyNe?: any;
  /** body (not contains) */
  bodyNotContains?: any;
  /** body (not icontains) */
  bodyNotIcontains?: any;
  /** body (startswith) */
  bodyStartswith?: string;
  contacts?: number[];
  /** contacts (in) */
  contactsIn?: string;
  /** contacts (is null) */
  contactsIsnull?: boolean;
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering
    
    * `created_at` - Created at
    * `-created_at` - Created at (descending)
    * `updated_at` - Updated at
    * `-updated_at` - Updated at (descending) */
  orderBy?: ("-created_at" | "-updated_at" | "created_at" | "updated_at")[];
  search?: string;
  /** search (contains) */
  searchContains?: string;
  /** search (endswith) */
  searchEndswith?: string;
  /** search (icontains) */
  searchIcontains?: string;
  /** search (equals, case-insensitive) */
  searchIexact?: string;
  /** search (in) */
  searchIn?: string;
  /** search (not equals, case-insensitive) */
  searchIne?: any;
  /** search (is empty or null) */
  searchIsempty?: any;
  /** search (is null) */
  searchIsnull?: string;
  /** search (not equals) */
  searchNe?: any;
  /** search (not contains) */
  searchNotContains?: any;
  /** search (not icontains) */
  searchNotIcontains?: any;
  /** search (startswith) */
  searchStartswith?: string;
  teammates?: number[];
  /** teammates (in) */
  teammatesIn?: string;
  /** teammates (is null) */
  teammatesIsnull?: boolean;
};
export type AppCrmContactNotesCreateApiResponse =
  /** status 201  */ ContactNote;
export type AppCrmContactNotesCreateApiArg = ContactNoteRequest;
export type AppCrmContactNotesRetrieveApiResponse =
  /** status 200  */ ContactNote;
export type AppCrmContactNotesRetrieveApiArg =
  /** A unique integer value identifying this contact note. */ number;
export type AppCrmContactNotesUpdateApiResponse =
  /** status 200  */ ContactNote;
export type AppCrmContactNotesUpdateApiArg = {
  /** A unique integer value identifying this contact note. */
  id: number;
  contactNoteRequest: ContactNoteRequest;
};
export type AppCrmContactNotesPartialUpdateApiResponse =
  /** status 200  */ ContactNote;
export type AppCrmContactNotesPartialUpdateApiArg = {
  /** A unique integer value identifying this contact note. */
  id: number;
  patchedContactNote: PatchedContactNote;
};
export type AppCrmContactNotesDestroyApiResponse = unknown;
export type AppCrmContactNotesDestroyApiArg =
  /** A unique integer value identifying this contact note. */ number;
export type AppCrmContactTagsListApiResponse =
  /** status 200  */ PaginatedTagList;
export type AppCrmContactTagsListApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** name (contains) */
  nameContains?: string;
  /** name (endswith) */
  nameEndswith?: string;
  /** name (icontains) */
  nameIcontains?: string;
  /** name (equals, case-insensitive) */
  nameIexact?: string;
  /** name (in) */
  nameIn?: string;
  /** name (not equals, case-insensitive) */
  nameIne?: any;
  /** name (is empty or null) */
  nameIsempty?: any;
  /** name (is null) */
  nameIsnull?: boolean;
  /** name (not equals) */
  nameNe?: any;
  /** name (not contains) */
  nameNotContains?: any;
  /** name (not icontains) */
  nameNotIcontains?: any;
  /** name (startswith) */
  nameStartswith?: string;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCrmContactTagsCreateApiResponse = /** status 201  */ Tag;
export type AppCrmContactTagsCreateApiArg = TagRequest;
export type AppCrmContactTagsRetrieveApiResponse = /** status 200  */ Tag;
export type AppCrmContactTagsRetrieveApiArg =
  /** A unique integer value identifying this tag. */ number;
export type AppCrmContactTagsUpdateApiResponse = /** status 200  */ Tag;
export type AppCrmContactTagsUpdateApiArg = {
  /** A unique integer value identifying this tag. */
  id: number;
  tagRequest: TagRequest;
};
export type AppCrmContactTagsPartialUpdateApiResponse = /** status 200  */ Tag;
export type AppCrmContactTagsPartialUpdateApiArg = {
  /** A unique integer value identifying this tag. */
  id: number;
  patchedTag: PatchedTag;
};
export type AppCrmContactTagsDestroyApiResponse = unknown;
export type AppCrmContactTagsDestroyApiArg =
  /** A unique integer value identifying this tag. */ number;
export type AppCrmContactTasksListApiResponse =
  /** status 200  */ PaginatedContactTaskList;
export type AppCrmContactTasksListApiArg = {
  allowedUsers?: number[];
  /** allowed_users (in) */
  allowedUsersIn?: string;
  /** allowed_users (is null) */
  allowedUsersIsnull?: boolean;
  assignee?: number;
  /** assignee (in) */
  assigneeIn?: string;
  /** assignee (is null) */
  assigneeIsnull?: boolean;
  contacts?: number[];
  /** contacts (in) */
  contactsIn?: string;
  /** contacts (is null) */
  contactsIsnull?: boolean;
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering
    
    * `due_date` - Due date
    * `-due_date` - Due date (descending)
    * `created_at` - Created at
    * `-created_at` - Created at (descending)
    * `updated_at` - Updated at
    * `-updated_at` - Updated at (descending) */
  orderBy?: (
    | "-created_at"
    | "-due_date"
    | "-updated_at"
    | "created_at"
    | "due_date"
    | "updated_at"
  )[];
  search?: string;
  /** search (contains) */
  searchContains?: string;
  /** search (endswith) */
  searchEndswith?: string;
  /** search (icontains) */
  searchIcontains?: string;
  /** search (equals, case-insensitive) */
  searchIexact?: string;
  /** search (in) */
  searchIn?: string;
  /** search (not equals, case-insensitive) */
  searchIne?: any;
  /** search (is empty or null) */
  searchIsempty?: any;
  /** search (is null) */
  searchIsnull?: string;
  /** search (not equals) */
  searchNe?: any;
  /** search (not contains) */
  searchNotContains?: any;
  /** search (not icontains) */
  searchNotIcontains?: any;
  /** search (startswith) */
  searchStartswith?: string;
  /** * `To-Do` - To-Do
   * `Completed` - Completed */
  status?: "Completed" | "To-Do";
  /** status (in) */
  statusIn?: string;
  /** status (is null) */
  statusIsnull?: boolean;
  teammates?: number[];
  /** teammates (in) */
  teammatesIn?: string;
  /** teammates (is null) */
  teammatesIsnull?: boolean;
  title?: string;
  /** title (contains) */
  titleContains?: string;
  /** title (endswith) */
  titleEndswith?: string;
  /** title (icontains) */
  titleIcontains?: string;
  /** title (equals, case-insensitive) */
  titleIexact?: string;
  /** title (in) */
  titleIn?: string;
  /** title (not equals, case-insensitive) */
  titleIne?: any;
  /** title (is empty or null) */
  titleIsempty?: any;
  /** title (is null) */
  titleIsnull?: boolean;
  /** title (not equals) */
  titleNe?: any;
  /** title (not contains) */
  titleNotContains?: any;
  /** title (not icontains) */
  titleNotIcontains?: any;
  /** title (startswith) */
  titleStartswith?: string;
};
export type AppCrmContactTasksCreateApiResponse =
  /** status 201  */ ContactTask;
export type AppCrmContactTasksCreateApiArg = ContactTaskRequest;
export type AppCrmContactTasksRetrieveApiResponse =
  /** status 200  */ ContactTask;
export type AppCrmContactTasksRetrieveApiArg =
  /** A unique integer value identifying this contact task. */ number;
export type AppCrmContactTasksUpdateApiResponse =
  /** status 200  */ ContactTask;
export type AppCrmContactTasksUpdateApiArg = {
  /** A unique integer value identifying this contact task. */
  id: number;
  contactTaskRequest: ContactTaskRequest;
};
export type AppCrmContactTasksPartialUpdateApiResponse =
  /** status 200  */ ContactTask;
export type AppCrmContactTasksPartialUpdateApiArg = {
  /** A unique integer value identifying this contact task. */
  id: number;
  patchedContactTask: PatchedContactTask;
};
export type AppCrmContactTasksDestroyApiResponse = unknown;
export type AppCrmContactTasksDestroyApiArg =
  /** A unique integer value identifying this contact task. */ number;
export type AppCrmContactTypesListApiResponse =
  /** status 200  */ PaginatedContactTypeList;
export type AppCrmContactTypesListApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** name (contains) */
  nameContains?: string;
  /** name (endswith) */
  nameEndswith?: string;
  /** name (icontains) */
  nameIcontains?: string;
  /** name (equals, case-insensitive) */
  nameIexact?: string;
  /** name (in) */
  nameIn?: string;
  /** name (not equals, case-insensitive) */
  nameIne?: any;
  /** name (is empty or null) */
  nameIsempty?: any;
  /** name (is null) */
  nameIsnull?: boolean;
  /** name (not equals) */
  nameNe?: any;
  /** name (not contains) */
  nameNotContains?: any;
  /** name (not icontains) */
  nameNotIcontains?: any;
  /** name (startswith) */
  nameStartswith?: string;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCrmContactTypesCreateApiResponse =
  /** status 201  */ ContactType;
export type AppCrmContactTypesCreateApiArg = ContactTypeRequest;
export type AppCrmContactTypesRetrieveApiResponse =
  /** status 200  */ ContactType;
export type AppCrmContactTypesRetrieveApiArg =
  /** A unique integer value identifying this contact type. */ number;
export type AppCrmContactTypesUpdateApiResponse =
  /** status 200  */ ContactType;
export type AppCrmContactTypesUpdateApiArg = {
  /** A unique integer value identifying this contact type. */
  id: number;
  contactTypeRequest: ContactTypeRequest;
};
export type AppCrmContactTypesPartialUpdateApiResponse =
  /** status 200  */ ContactType;
export type AppCrmContactTypesPartialUpdateApiArg = {
  /** A unique integer value identifying this contact type. */
  id: number;
  patchedContactType: PatchedContactType;
};
export type AppCrmContactTypesDestroyApiResponse = unknown;
export type AppCrmContactTypesDestroyApiArg =
  /** A unique integer value identifying this contact type. */ number;
export type AppCrmContactsListApiResponse =
  /** status 200  */ PaginatedContactList;
export type AppCrmContactsListApiArg = {
  allEmails?: string[];
  /** all_emails (contains) */
  allEmailsContains?: string[];
  /** all_emails (overlap) */
  allEmailsOverlap?: string[];
  company?: number;
  /** company (in) */
  companyIn?: string;
  /** company (is null) */
  companyIsnull?: boolean;
  contactFieldTemplate?: string;
  /** contact_field_template (in) */
  contactFieldTemplateIn?: string;
  /** contact_field_template (is null) */
  contactFieldTemplateIsnull?: string;
  contactType?: number;
  /** contact_type (in) */
  contactTypeIn?: string;
  /** contact_type (is null) */
  contactTypeIsnull?: boolean;
  createdAt?: string;
  /** created_at (greater than) */
  createdAtGt?: string;
  /** created_at (greater than or equal to) */
  createdAtGte?: string;
  /** created_at (in) */
  createdAtIn?: string;
  /** created_at (is null) */
  createdAtIsnull?: boolean;
  /** created_at (less than) */
  createdAtLt?: string;
  /** created_at (less than or equal to) */
  createdAtLte?: string;
  /** requires field_template to be used with it */
  fieldValue?: string;
  /** field_value (contains) */
  fieldValueContains?: string;
  /** field_value (endswith) */
  fieldValueEndswith?: string;
  /** field_value (greater than) */
  fieldValueGt?: string;
  /** field_value (greater than or equal to) */
  fieldValueGte?: string;
  /** field_value (icontains) */
  fieldValueIcontains?: string;
  /** field_value (equals, case-insensitive) */
  fieldValueIexact?: string;
  /** field_value (in) */
  fieldValueIn?: string;
  /** field_value (not equals, case-insensitive) */
  fieldValueIne?: any;
  /** field_value (is empty or null) */
  fieldValueIsempty?: any;
  /** field_value (is null) */
  fieldValueIsnull?: string;
  /** field_value (less than) */
  fieldValueLt?: string;
  /** field_value (less than or equal to) */
  fieldValueLte?: string;
  /** field_value (not equals) */
  fieldValueNe?: any;
  /** field_value (not contains) */
  fieldValueNotContains?: any;
  /** field_value (not icontains) */
  fieldValueNotIcontains?: any;
  /** field_value (startswith) */
  fieldValueStartswith?: string;
  hiddenDate?: string;
  /** hidden_date (greater than) */
  hiddenDateGt?: string;
  /** hidden_date (greater than or equal to) */
  hiddenDateGte?: string;
  /** hidden_date (in) */
  hiddenDateIn?: string;
  /** hidden_date (is null) */
  hiddenDateIsnull?: boolean;
  /** hidden_date (less than) */
  hiddenDateLt?: string;
  /** hidden_date (less than or equal to) */
  hiddenDateLte?: string;
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  isResource?: boolean;
  /** is_resource (in) */
  isResourceIn?: string;
  /** is_resource (is null) */
  isResourceIsnull?: boolean;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** name (contains) */
  nameContains?: string;
  /** name (endswith) */
  nameEndswith?: string;
  /** name (icontains) */
  nameIcontains?: string;
  /** name (equals, case-insensitive) */
  nameIexact?: string;
  /** name (in) */
  nameIn?: string;
  /** name (not equals, case-insensitive) */
  nameIne?: any;
  /** name (is empty or null) */
  nameIsempty?: any;
  /** name (is null) */
  nameIsnull?: boolean;
  /** name (not equals) */
  nameNe?: any;
  /** name (not contains) */
  nameNotContains?: any;
  /** name (not icontains) */
  nameNotIcontains?: any;
  /** name (startswith) */
  nameStartswith?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering
    
    * `id` - Id
    * `-id` - Id (descending)
    * `primary_email` - Primary email
    * `-primary_email` - Primary email (descending)
    * `name` - Name
    * `-name` - Name (descending)
    * `title` - Title
    * `-title` - Title (descending)
    * `tags` - Tags
    * `-tags` - Tags (descending)
    * `contact_type` - Contact type
    * `-contact_type` - Contact type (descending)
    * `field_value` - Field value
    * `-field_value` - Field value (descending)
    * `created_at` - Created at
    * `-created_at` - Created at (descending)
    * `updated_at` - Updated at
    * `-updated_at` - Updated at (descending) */
  orderBy?: (
    | "-contact_type"
    | "-created_at"
    | "-field_value"
    | "-id"
    | "-name"
    | "-primary_email"
    | "-tags"
    | "-title"
    | "-updated_at"
    | "contact_type"
    | "created_at"
    | "field_value"
    | "id"
    | "name"
    | "primary_email"
    | "tags"
    | "title"
    | "updated_at"
  )[];
  primaryEmail?: string;
  /** primary_email (contains) */
  primaryEmailContains?: string;
  /** primary_email (endswith) */
  primaryEmailEndswith?: string;
  /** primary_email (icontains) */
  primaryEmailIcontains?: string;
  /** primary_email (equals, case-insensitive) */
  primaryEmailIexact?: string;
  /** primary_email (in) */
  primaryEmailIn?: string;
  /** primary_email (not equals, case-insensitive) */
  primaryEmailIne?: any;
  /** primary_email (is empty or null) */
  primaryEmailIsempty?: any;
  /** primary_email (is null) */
  primaryEmailIsnull?: boolean;
  /** primary_email (not equals) */
  primaryEmailNe?: any;
  /** primary_email (not contains) */
  primaryEmailNotContains?: any;
  /** primary_email (not icontains) */
  primaryEmailNotIcontains?: any;
  /** primary_email (startswith) */
  primaryEmailStartswith?: string;
  search?: string;
  /** search (contains) */
  searchContains?: string;
  /** search (endswith) */
  searchEndswith?: string;
  /** search (icontains) */
  searchIcontains?: string;
  /** search (equals, case-insensitive) */
  searchIexact?: string;
  /** search (in) */
  searchIn?: string;
  /** search (not equals, case-insensitive) */
  searchIne?: any;
  /** search (is empty or null) */
  searchIsempty?: any;
  /** search (is null) */
  searchIsnull?: string;
  /** search (not equals) */
  searchNe?: any;
  /** search (not contains) */
  searchNotContains?: any;
  /** search (not icontains) */
  searchNotIcontains?: any;
  /** search (startswith) */
  searchStartswith?: string;
  tags?: number[];
  /** tags (in) */
  tagsIn?: string;
  /** tags (is null) */
  tagsIsnull?: boolean;
  title?: string;
  /** title (contains) */
  titleContains?: string;
  /** title (endswith) */
  titleEndswith?: string;
  /** title (icontains) */
  titleIcontains?: string;
  /** title (equals, case-insensitive) */
  titleIexact?: string;
  /** title (in) */
  titleIn?: string;
  /** title (not equals, case-insensitive) */
  titleIne?: any;
  /** title (is empty or null) */
  titleIsempty?: any;
  /** title (is null) */
  titleIsnull?: boolean;
  /** title (not equals) */
  titleNe?: any;
  /** title (not contains) */
  titleNotContains?: any;
  /** title (not icontains) */
  titleNotIcontains?: any;
  /** title (startswith) */
  titleStartswith?: string;
  updatedAt?: string;
  /** updated_at (greater than) */
  updatedAtGt?: string;
  /** updated_at (greater than or equal to) */
  updatedAtGte?: string;
  /** updated_at (in) */
  updatedAtIn?: string;
  /** updated_at (is null) */
  updatedAtIsnull?: boolean;
  /** updated_at (less than) */
  updatedAtLt?: string;
  /** updated_at (less than or equal to) */
  updatedAtLte?: string;
};
export type AppCrmContactsCreateApiResponse = /** status 201  */ Contact;
export type AppCrmContactsCreateApiArg = ContactRequest;
export type AppCrmContactsRetrieveApiResponse = /** status 200  */ Contact;
export type AppCrmContactsRetrieveApiArg =
  /** A unique integer value identifying this contact. */ number;
export type AppCrmContactsUpdateApiResponse = /** status 200  */ Contact;
export type AppCrmContactsUpdateApiArg = {
  /** A unique integer value identifying this contact. */
  id: number;
  contactRequest: ContactRequest;
};
export type AppCrmContactsPartialUpdateApiResponse = /** status 200  */ Contact;
export type AppCrmContactsPartialUpdateApiArg = {
  /** A unique integer value identifying this contact. */
  id: number;
  patchedContact: PatchedContact;
};
export type AppCrmContactsDestroyApiResponse = unknown;
export type AppCrmContactsDestroyApiArg =
  /** A unique integer value identifying this contact. */ number;
export type AppCrmContactsMergeCreateApiResponse = /** status 200  */ Contact;
export type AppCrmContactsMergeCreateApiArg = MergeContactsInputRequest;
export type AppCrmEventBriefsListApiResponse = /** status 200  */ EventBrief[];
export type AppCrmEventBriefsListApiArg = void;
export type AppCrmEventBriefsCreateApiResponse = /** status 201  */ EventBrief;
export type AppCrmEventBriefsCreateApiArg = EventBriefCreateRequest;
export type AppCrmEventBriefsExternalListApiResponse =
  /** status 200  */ EventBriefExternal[];
export type AppCrmEventBriefsExternalListApiArg = void;
export type AppCrmEventBriefsExternalCreateApiResponse =
  /** status 201  */ EventBriefExternal;
export type AppCrmEventBriefsExternalCreateApiArg = EventBriefExternalRequest;
export type AppCrmEventBriefsExternalRetrieveApiResponse =
  /** status 200  */ EventBriefExternal;
export type AppCrmEventBriefsExternalRetrieveApiArg = string;
export type AppCrmEventBriefsExternalUpdateApiResponse =
  /** status 200  */ EventBriefExternal;
export type AppCrmEventBriefsExternalUpdateApiArg = {
  urlKey: string;
  eventBriefExternalRequest: EventBriefExternalRequest;
};
export type AppCrmEventBriefsExternalPartialUpdateApiResponse =
  /** status 200  */ EventBriefExternal;
export type AppCrmEventBriefsExternalPartialUpdateApiArg = {
  urlKey: string;
  patchedEventBriefExternal: PatchedEventBriefExternal;
};
export type AppCrmEventBriefsExternalDestroyApiResponse = unknown;
export type AppCrmEventBriefsExternalDestroyApiArg = string;
export type AppCrmEventBriefsRetrieveApiResponse =
  /** status 200  */ EventBrief;
export type AppCrmEventBriefsRetrieveApiArg = string;
export type AppCrmEventBriefsUpdateApiResponse = /** status 200  */ EventBrief;
export type AppCrmEventBriefsUpdateApiArg = {
  eventUniqueId: string;
  eventBriefRequest: EventBriefRequest;
};
export type AppCrmEventBriefsPartialUpdateApiResponse =
  /** status 200  */ EventBrief;
export type AppCrmEventBriefsPartialUpdateApiArg = {
  eventUniqueId: string;
  patchedEventBrief: PatchedEventBrief;
};
export type AppCrmEventBriefsDestroyApiResponse = unknown;
export type AppCrmEventBriefsDestroyApiArg = string;
export type AppCrmLeaderRelationshipsListApiResponse =
  /** status 200  */ PaginatedLeaderRelationshipList;
export type AppCrmLeaderRelationshipsListApiArg = {
  allEmails?: string[];
  /** all_emails (contains) */
  allEmailsContains?: string[];
  /** all_emails (overlap) */
  allEmailsOverlap?: string[];
  company?: number;
  /** company (in) */
  companyIn?: string;
  /** company (is null) */
  companyIsnull?: boolean;
  contact?: number;
  contactCadence?: string;
  /** contact_cadence (contains) */
  contactCadenceContains?: string;
  /** contact_cadence (endswith) */
  contactCadenceEndswith?: string;
  /** contact_cadence (icontains) */
  contactCadenceIcontains?: string;
  /** contact_cadence (equals, case-insensitive) */
  contactCadenceIexact?: string;
  /** contact_cadence (in) */
  contactCadenceIn?: string;
  /** contact_cadence (not equals, case-insensitive) */
  contactCadenceIne?: any;
  /** contact_cadence (is empty or null) */
  contactCadenceIsempty?: any;
  /** contact_cadence (is null) */
  contactCadenceIsnull?: string;
  /** contact_cadence (not equals) */
  contactCadenceNe?: any;
  /** contact_cadence (not contains) */
  contactCadenceNotContains?: any;
  /** contact_cadence (not icontains) */
  contactCadenceNotIcontains?: any;
  /** contact_cadence (startswith) */
  contactCadenceStartswith?: string;
  contactCadenceStatus?: string;
  /** contact_cadence_status (contains) */
  contactCadenceStatusContains?: string;
  /** contact_cadence_status (endswith) */
  contactCadenceStatusEndswith?: string;
  /** contact_cadence_status (icontains) */
  contactCadenceStatusIcontains?: string;
  /** contact_cadence_status (equals, case-insensitive) */
  contactCadenceStatusIexact?: string;
  /** contact_cadence_status (in) */
  contactCadenceStatusIn?: string;
  /** contact_cadence_status (not equals, case-insensitive) */
  contactCadenceStatusIne?: any;
  /** contact_cadence_status (is empty or null) */
  contactCadenceStatusIsempty?: any;
  /** contact_cadence_status (is null) */
  contactCadenceStatusIsnull?: string;
  /** contact_cadence_status (not equals) */
  contactCadenceStatusNe?: any;
  /** contact_cadence_status (not contains) */
  contactCadenceStatusNotContains?: any;
  /** contact_cadence_status (not icontains) */
  contactCadenceStatusNotIcontains?: any;
  /** contact_cadence_status (startswith) */
  contactCadenceStatusStartswith?: string;
  contactCreatedAt?: string;
  /** contact_created_at (greater than) */
  contactCreatedAtGt?: string;
  /** contact_created_at (greater than or equal to) */
  contactCreatedAtGte?: string;
  /** contact_created_at (in) */
  contactCreatedAtIn?: string;
  /** contact_created_at (is null) */
  contactCreatedAtIsnull?: boolean;
  /** contact_created_at (less than) */
  contactCreatedAtLt?: string;
  /** contact_created_at (less than or equal to) */
  contactCreatedAtLte?: string;
  contactHiddenDate?: string;
  /** contact_hidden_date (greater than) */
  contactHiddenDateGt?: string;
  /** contact_hidden_date (greater than or equal to) */
  contactHiddenDateGte?: string;
  /** contact_hidden_date (in) */
  contactHiddenDateIn?: string;
  /** contact_hidden_date (is null) */
  contactHiddenDateIsnull?: boolean;
  /** contact_hidden_date (less than) */
  contactHiddenDateLt?: string;
  /** contact_hidden_date (less than or equal to) */
  contactHiddenDateLte?: string;
  /** contact (in) */
  contactIn?: string;
  /** contact (is null) */
  contactIsnull?: boolean;
  contactTags?: number[];
  /** contact_tags (in) */
  contactTagsIn?: string;
  /** contact_tags (is null) */
  contactTagsIsnull?: boolean;
  contactType?: number;
  /** contact_type (in) */
  contactTypeIn?: string;
  /** contact_type (is null) */
  contactTypeIsnull?: boolean;
  contactUpdatedAt?: string;
  /** contact_updated_at (greater than) */
  contactUpdatedAtGt?: string;
  /** contact_updated_at (greater than or equal to) */
  contactUpdatedAtGte?: string;
  /** contact_updated_at (in) */
  contactUpdatedAtIn?: string;
  /** contact_updated_at (is null) */
  contactUpdatedAtIsnull?: boolean;
  /** contact_updated_at (less than) */
  contactUpdatedAtLt?: string;
  /** contact_updated_at (less than or equal to) */
  contactUpdatedAtLte?: string;
  createdAt?: string;
  /** created_at (greater than) */
  createdAtGt?: string;
  /** created_at (greater than or equal to) */
  createdAtGte?: string;
  /** created_at (in) */
  createdAtIn?: string;
  /** created_at (is null) */
  createdAtIsnull?: boolean;
  /** created_at (less than) */
  createdAtLt?: string;
  /** created_at (less than or equal to) */
  createdAtLte?: string;
  fieldTemplate?: string;
  /** field_template (in) */
  fieldTemplateIn?: string;
  /** field_template (is null) */
  fieldTemplateIsnull?: string;
  /** requires field_template to be used with it */
  fieldValue?: string;
  /** field_value (contains) */
  fieldValueContains?: string;
  /** field_value (endswith) */
  fieldValueEndswith?: string;
  /** field_value (greater than) */
  fieldValueGt?: string;
  /** field_value (greater than or equal to) */
  fieldValueGte?: string;
  /** field_value (icontains) */
  fieldValueIcontains?: string;
  /** field_value (equals, case-insensitive) */
  fieldValueIexact?: string;
  /** field_value (in) */
  fieldValueIn?: string;
  /** field_value (not equals, case-insensitive) */
  fieldValueIne?: any;
  /** field_value (is empty or null) */
  fieldValueIsempty?: any;
  /** field_value (is null) */
  fieldValueIsnull?: string;
  /** field_value (less than) */
  fieldValueLt?: string;
  /** field_value (less than or equal to) */
  fieldValueLte?: string;
  /** field_value (not equals) */
  fieldValueNe?: any;
  /** field_value (not contains) */
  fieldValueNotContains?: any;
  /** field_value (not icontains) */
  fieldValueNotIcontains?: any;
  /** field_value (startswith) */
  fieldValueStartswith?: string;
  hiddenDate?: string;
  /** hidden_date (greater than) */
  hiddenDateGt?: string;
  /** hidden_date (greater than or equal to) */
  hiddenDateGte?: string;
  /** hidden_date (in) */
  hiddenDateIn?: string;
  /** hidden_date (is null) */
  hiddenDateIsnull?: boolean;
  /** hidden_date (less than) */
  hiddenDateLt?: string;
  /** hidden_date (less than or equal to) */
  hiddenDateLte?: string;
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  leader?: number;
  /** leader (in) */
  leaderIn?: string;
  /** leader (is null) */
  leaderIsnull?: boolean;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** name (contains) */
  nameContains?: string;
  /** name (endswith) */
  nameEndswith?: string;
  /** name (icontains) */
  nameIcontains?: string;
  /** name (equals, case-insensitive) */
  nameIexact?: string;
  /** name (in) */
  nameIn?: string;
  /** name (not equals, case-insensitive) */
  nameIne?: any;
  /** name (is empty or null) */
  nameIsempty?: any;
  /** name (is null) */
  nameIsnull?: boolean;
  /** name (not equals) */
  nameNe?: any;
  /** name (not contains) */
  nameNotContains?: any;
  /** name (not icontains) */
  nameNotIcontains?: any;
  /** name (startswith) */
  nameStartswith?: string;
  nextMeetingDataStart?: string;
  /** next_meeting_data_start (greater than) */
  nextMeetingDataStartGt?: string;
  /** next_meeting_data_start (greater than or equal to) */
  nextMeetingDataStartGte?: string;
  /** next_meeting_data_start (in) */
  nextMeetingDataStartIn?: string;
  /** next_meeting_data_start (is null) */
  nextMeetingDataStartIsnull?: boolean;
  /** next_meeting_data_start (less than) */
  nextMeetingDataStartLt?: string;
  /** next_meeting_data_start (less than or equal to) */
  nextMeetingDataStartLte?: string;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Ordering
    
    * `primary_email` - Primary email
    * `-primary_email` - Primary email (descending)
    * `name` - Name
    * `-name` - Name (descending)
    * `title` - Title
    * `-title` - Title (descending)
    * `contact_created_at` - Contact created at
    * `-contact_created_at` - Contact created at (descending)
    * `contact_updated_at` - Contact updated at
    * `-contact_updated_at` - Contact updated at (descending)
    * `relationship_strength` - Relationship strength
    * `-relationship_strength` - Relationship strength (descending)
    * `relationship_strength_auto` - Relationship strength auto
    * `-relationship_strength_auto` - Relationship strength auto (descending)
    * `relationship_strength_override` - Relationship strength override
    * `-relationship_strength_override` - Relationship strength override (descending)
    * `prev_meeting_data_start` - Prev meeting data start
    * `-prev_meeting_data_start` - Prev meeting data start (descending)
    * `next_meeting_data_start` - Next meeting data start
    * `-next_meeting_data_start` - Next meeting data start (descending)
    * `tags` - Tags
    * `-tags` - Tags (descending)
    * `contact_tags` - Contact tags
    * `-contact_tags` - Contact tags (descending)
    * `contact_cadence` - Contact cadence
    * `-contact_cadence` - Contact cadence (descending)
    * `contact_cadence_status` - Contact cadence status
    * `-contact_cadence_status` - Contact cadence status (descending) */
  orderBy?: (
    | "-contact_cadence"
    | "-contact_cadence_status"
    | "-contact_created_at"
    | "-contact_tags"
    | "-contact_updated_at"
    | "-name"
    | "-next_meeting_data_start"
    | "-prev_meeting_data_start"
    | "-primary_email"
    | "-relationship_strength"
    | "-relationship_strength_auto"
    | "-relationship_strength_override"
    | "-tags"
    | "-title"
    | "contact_cadence"
    | "contact_cadence_status"
    | "contact_created_at"
    | "contact_tags"
    | "contact_updated_at"
    | "name"
    | "next_meeting_data_start"
    | "prev_meeting_data_start"
    | "primary_email"
    | "relationship_strength"
    | "relationship_strength_auto"
    | "relationship_strength_override"
    | "tags"
    | "title"
  )[];
  prevMeetingDataStart?: string;
  /** prev_meeting_data_start (greater than) */
  prevMeetingDataStartGt?: string;
  /** prev_meeting_data_start (greater than or equal to) */
  prevMeetingDataStartGte?: string;
  /** prev_meeting_data_start (in) */
  prevMeetingDataStartIn?: string;
  /** prev_meeting_data_start (is null) */
  prevMeetingDataStartIsnull?: boolean;
  /** prev_meeting_data_start (less than) */
  prevMeetingDataStartLt?: string;
  /** prev_meeting_data_start (less than or equal to) */
  prevMeetingDataStartLte?: string;
  primaryEmail?: string;
  /** primary_email (contains) */
  primaryEmailContains?: string;
  /** primary_email (endswith) */
  primaryEmailEndswith?: string;
  /** primary_email (icontains) */
  primaryEmailIcontains?: string;
  /** primary_email (equals, case-insensitive) */
  primaryEmailIexact?: string;
  /** primary_email (in) */
  primaryEmailIn?: string;
  /** primary_email (not equals, case-insensitive) */
  primaryEmailIne?: any;
  /** primary_email (is empty or null) */
  primaryEmailIsempty?: any;
  /** primary_email (is null) */
  primaryEmailIsnull?: boolean;
  /** primary_email (not equals) */
  primaryEmailNe?: any;
  /** primary_email (not contains) */
  primaryEmailNotContains?: any;
  /** primary_email (not icontains) */
  primaryEmailNotIcontains?: any;
  /** primary_email (startswith) */
  primaryEmailStartswith?: string;
  /** * `weak` - Weak
   * `good` - Good
   * `strong` - Strong */
  relationshipStrength?: "good" | "strong" | "weak";
  relationshipStrengthAuto?: number;
  /** relationship_strength_auto (greater than) */
  relationshipStrengthAutoGt?: number;
  /** relationship_strength_auto (greater than or equal to) */
  relationshipStrengthAutoGte?: number;
  /** relationship_strength_auto (in) */
  relationshipStrengthAutoIn?: string;
  /** relationship_strength_auto (is null) */
  relationshipStrengthAutoIsnull?: boolean;
  /** relationship_strength_auto (less than) */
  relationshipStrengthAutoLt?: number;
  /** relationship_strength_auto (less than or equal to) */
  relationshipStrengthAutoLte?: number;
  /** relationship_strength (in) */
  relationshipStrengthIn?: string;
  /** relationship_strength (is null) */
  relationshipStrengthIsnull?: string;
  relationshipStrengthOverride?: boolean;
  /** relationship_strength_override (in) */
  relationshipStrengthOverrideIn?: boolean;
  /** relationship_strength_override (is null) */
  relationshipStrengthOverrideIsnull?: boolean;
  relationshipType?: number;
  /** relationship_type (in) */
  relationshipTypeIn?: string;
  /** relationship_type (is null) */
  relationshipTypeIsnull?: boolean;
  /** * `manual` - Manual
   * `etl` - ETL */
  source?: ("etl" | "manual") | null;
  /** source (in) */
  sourceIn?: string;
  /** source (is null) */
  sourceIsnull?: boolean;
  tags?: number[];
  /** tags (in) */
  tagsIn?: string;
  /** tags (is null) */
  tagsIsnull?: boolean;
  title?: string;
  /** title (contains) */
  titleContains?: string;
  /** title (endswith) */
  titleEndswith?: string;
  /** title (icontains) */
  titleIcontains?: string;
  /** title (equals, case-insensitive) */
  titleIexact?: string;
  /** title (in) */
  titleIn?: string;
  /** title (not equals, case-insensitive) */
  titleIne?: any;
  /** title (is empty or null) */
  titleIsempty?: any;
  /** title (is null) */
  titleIsnull?: boolean;
  /** title (not equals) */
  titleNe?: any;
  /** title (not contains) */
  titleNotContains?: any;
  /** title (not icontains) */
  titleNotIcontains?: any;
  /** title (startswith) */
  titleStartswith?: string;
  updatedAt?: string;
  /** updated_at (greater than) */
  updatedAtGt?: string;
  /** updated_at (greater than or equal to) */
  updatedAtGte?: string;
  /** updated_at (in) */
  updatedAtIn?: string;
  /** updated_at (is null) */
  updatedAtIsnull?: boolean;
  /** updated_at (less than) */
  updatedAtLt?: string;
  /** updated_at (less than or equal to) */
  updatedAtLte?: string;
};
export type AppCrmLeaderRelationshipsCreateApiResponse =
  /** status 201  */ LeaderRelationship;
export type AppCrmLeaderRelationshipsCreateApiArg = LeaderRelationshipRequest;
export type AppCrmLeaderRelationshipsRetrieveApiResponse =
  /** status 200  */ LeaderRelationship;
export type AppCrmLeaderRelationshipsRetrieveApiArg =
  /** A unique integer value identifying this leader relationship. */ number;
export type AppCrmLeaderRelationshipsUpdateApiResponse =
  /** status 200  */ LeaderRelationship;
export type AppCrmLeaderRelationshipsUpdateApiArg = {
  /** A unique integer value identifying this leader relationship. */
  id: number;
  leaderRelationshipRequest: LeaderRelationshipRequest;
};
export type AppCrmLeaderRelationshipsPartialUpdateApiResponse =
  /** status 200  */ LeaderRelationship;
export type AppCrmLeaderRelationshipsPartialUpdateApiArg = {
  /** A unique integer value identifying this leader relationship. */
  id: number;
  patchedLeaderRelationship: PatchedLeaderRelationship;
};
export type AppCrmLeaderRelationshipsDestroyApiResponse = unknown;
export type AppCrmLeaderRelationshipsDestroyApiArg =
  /** A unique integer value identifying this leader relationship. */ number;
export type AppCrmPreferencesListApiResponse =
  /** status 200  */ CrmPreferences[];
export type AppCrmPreferencesListApiArg = void;
export type AppCrmPreferencesCreateApiResponse =
  /** status 201  */ CrmPreferences;
export type AppCrmPreferencesCreateApiArg = CrmPreferencesRequest;
export type AppCrmPreferencesRetrieveApiResponse =
  /** status 200  */ CrmPreferences;
export type AppCrmPreferencesRetrieveApiArg =
  /** A unique integer value identifying this CRM Preferences. */ number;
export type AppCrmPreferencesUpdateApiResponse =
  /** status 200  */ CrmPreferences;
export type AppCrmPreferencesUpdateApiArg = {
  /** A unique integer value identifying this CRM Preferences. */
  id: number;
  crmPreferencesRequest: CrmPreferencesRequest;
};
export type AppCrmPreferencesPartialUpdateApiResponse =
  /** status 200  */ CrmPreferences;
export type AppCrmPreferencesPartialUpdateApiArg = {
  /** A unique integer value identifying this CRM Preferences. */
  id: number;
  patchedCrmPreferences: PatchedCrmPreferences;
};
export type AppCrmPreferencesDestroyApiResponse = unknown;
export type AppCrmPreferencesDestroyApiArg =
  /** A unique integer value identifying this CRM Preferences. */ number;
export type AppCrmPrivateContactsListApiResponse =
  /** status 200  */ LeaderPrivateContacts[];
export type AppCrmPrivateContactsListApiArg = void;
export type AppCrmPrivateContactsAddPrivateContactCreateApiResponse =
  /** status 200  */ LeaderPrivateContacts;
export type AppCrmPrivateContactsAddPrivateContactCreateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  addRemovePrivateContactInputRequest: AddRemovePrivateContactInputRequest;
};
export type AppCrmPrivateContactsRemovePrivateContactCreateApiResponse =
  /** status 200  */ LeaderPrivateContacts;
export type AppCrmPrivateContactsRemovePrivateContactCreateApiArg = {
  /** A unique integer value identifying this leader. */
  id: number;
  addRemovePrivateContactInputRequest: AddRemovePrivateContactInputRequest;
};
export type AppCrmRelationshipTagsListApiResponse =
  /** status 200  */ PaginatedRelationshipTagList;
export type AppCrmRelationshipTagsListApiArg = {
  id?: number;
  /** id (greater than) */
  idGt?: number;
  /** id (greater than or equal to) */
  idGte?: number;
  /** id (in) */
  idIn?: string;
  /** id (is null) */
  idIsnull?: boolean;
  /** id (less than) */
  idLt?: number;
  /** id (less than or equal to) */
  idLte?: number;
  /** Number of results to return per page. */
  limit?: number;
  name?: string;
  /** name (contains) */
  nameContains?: string;
  /** name (endswith) */
  nameEndswith?: string;
  /** name (icontains) */
  nameIcontains?: string;
  /** name (equals, case-insensitive) */
  nameIexact?: string;
  /** name (in) */
  nameIn?: string;
  /** name (not equals, case-insensitive) */
  nameIne?: any;
  /** name (is empty or null) */
  nameIsempty?: any;
  /** name (is null) */
  nameIsnull?: boolean;
  /** name (not equals) */
  nameNe?: any;
  /** name (not contains) */
  nameNotContains?: any;
  /** name (not icontains) */
  nameNotIcontains?: any;
  /** name (startswith) */
  nameStartswith?: string;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AppCrmRelationshipTagsCreateApiResponse =
  /** status 201  */ RelationshipTag;
export type AppCrmRelationshipTagsCreateApiArg = RelationshipTagRequest;
export type AppCrmRelationshipTagsRetrieveApiResponse =
  /** status 200  */ RelationshipTag;
export type AppCrmRelationshipTagsRetrieveApiArg =
  /** A unique integer value identifying this relationship tag. */ number;
export type AppCrmRelationshipTagsUpdateApiResponse =
  /** status 200  */ RelationshipTag;
export type AppCrmRelationshipTagsUpdateApiArg = {
  /** A unique integer value identifying this relationship tag. */
  id: number;
  relationshipTagRequest: RelationshipTagRequest;
};
export type AppCrmRelationshipTagsPartialUpdateApiResponse =
  /** status 200  */ RelationshipTag;
export type AppCrmRelationshipTagsPartialUpdateApiArg = {
  /** A unique integer value identifying this relationship tag. */
  id: number;
  patchedRelationshipTag: PatchedRelationshipTag;
};
export type AppCrmRelationshipTagsDestroyApiResponse = unknown;
export type AppCrmRelationshipTagsDestroyApiArg =
  /** A unique integer value identifying this relationship tag. */ number;
export type Company = {
  id: number;
  name: string;
  email_domain: string;
  notes?: string | null;
  logo?: string | null;
  hidden_date?: string | null;
  organization?: number;
  category?: number | null;
  primary_contact?: number | null;
};
export type ContactDateValueMeta = {
  timezone: string;
};
export type ContactFieldMeta = {
  date_value?: ContactDateValueMeta | null;
};
export type ContactField = {
  text_value?: string | null;
  choices?: number[] | null;
  meta?: ContactFieldMeta | null;
};
export type ContactEmail = {
  id: number;
  /** Email address */
  email: string;
  /** Whether this is the primary email for the contact */
  is_primary?: boolean;
  /** Organization this email belongs to */
  organization: number;
  created_at?: string;
  updated_at?: string;
};
export type Contact = {
  id: number;
  created_at?: string;
  updated_at?: string;
  timezone?: string | null;
  fields?: {
    [key: string]: ContactField;
  };
  tags?: number[];
  emails: ContactEmail[];
  primary_email?: string;
  all_emails?: string[];
  name: string | null;
  title?: string | null;
  location?: string | null;
  assistant_name?: string | null;
  assistant_email?: string | null;
  phone_number?: string | null;
  linkedin_url?: string | null;
  is_resource?: boolean;
  last_observed_email?: string | null;
  last_observed_name?: string | null;
  avatar?: string | null;
  hidden_date?: string | null;
  contact_category?: number | null;
  organization?: number | null;
  contact_type?: number | null;
  company?: number | null;
  leaders: (number | null)[];
  private_leaders?: (number | null)[];
};
export type PaginatedCompanyList = {
  data: Company[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: {
      primary_contact?: {
        [key: string]: Contact;
      };
    };
  };
};
export type CompanyRequest = {
  name: string;
  email_domain: string;
  notes?: string | null;
  logo?: Blob | null;
  hidden_date?: string | null;
  organization?: number;
  category?: number | null;
  primary_contact?: number | null;
};
export type PatchedCompany = {
  name?: string;
  email_domain?: string;
  notes?: string | null;
  logo?: Blob | null;
  hidden_date?: string | null;
  organization?: number;
  category?: number | null;
  primary_contact?: number | null;
};
export type CompanyCategory = {
  id: number;
  created_at?: string;
  updated_at?: string;
  name: string;
  color?: string;
  organization?: number;
};
export type PaginatedCompanyCategoryList = {
  data: CompanyCategory[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type CompanyCategoryRequest = {
  created_at?: string;
  updated_at?: string;
  name: string;
  color?: string;
  organization?: number;
};
export type PatchedCompanyCategory = {
  created_at?: string;
  updated_at?: string;
  name?: string;
  color?: string;
  organization?: number;
};
export type ContactCadence = {
  id: number;
  created_at: string;
  updated_at: string;
  start_date: string;
  /** * `fixed_duration` - Fixed Duration
   * `weekly` - Weekly
   * `bi_weekly` - Bi-Weekly
   * `monthly` - Monthly
   * `quarterly` - Quarterly
   * `annually` - Annually */
  frequency_type:
    | "fixed_duration"
    | "weekly"
    | "bi_weekly"
    | "monthly"
    | "quarterly"
    | "annually";
  meeting_frequency: string | null;
  advance_notice: string;
  created_by: number | null;
  updated_by: number | null;
  contact: number;
  teammate: number;
};
export type PaginatedContactCadenceList = {
  data: ContactCadence[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactCadenceRequest = {
  created_at?: string;
  start_date: string;
  /** * `fixed_duration` - Fixed Duration
   * `weekly` - Weekly
   * `bi_weekly` - Bi-Weekly
   * `monthly` - Monthly
   * `quarterly` - Quarterly
   * `annually` - Annually */
  frequency_type:
    | "fixed_duration"
    | "weekly"
    | "bi_weekly"
    | "monthly"
    | "quarterly"
    | "annually";
  meeting_frequency?: string | null;
  advance_notice: string;
  created_by?: number | null;
  updated_by?: number | null;
  contact: number;
  teammate: number;
};
export type PatchedContactCadence = {
  created_at?: string;
  start_date?: string;
  /** * `fixed_duration` - Fixed Duration
   * `weekly` - Weekly
   * `bi_weekly` - Bi-Weekly
   * `monthly` - Monthly
   * `quarterly` - Quarterly
   * `annually` - Annually */
  frequency_type?:
    | "fixed_duration"
    | "weekly"
    | "bi_weekly"
    | "monthly"
    | "quarterly"
    | "annually";
  meeting_frequency?: string | null;
  advance_notice?: string;
  created_by?: number | null;
  updated_by?: number | null;
  contact?: number;
  teammate?: number;
};
export type Tag = {
  id: number;
  name: string;
  color: string;
  organization: number;
};
export type PaginatedTagList = {
  data: Tag[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type TagRequest = {
  name: string;
  color: string;
};
export type PatchedTag = {
  name?: string;
  color?: string;
};
export type PaginatedContactEmailList = {
  data: ContactEmail[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactEmailRequest = {
  /** Email address */
  email: string;
  /** Whether this is the primary email for the contact */
  is_primary?: boolean;
  /** Organization this email belongs to */
  organization: number;
  created_at?: string;
  updated_at?: string;
};
export type PatchedContactEmail = {
  /** Email address */
  email?: string;
  /** Whether this is the primary email for the contact */
  is_primary?: boolean;
  /** Organization this email belongs to */
  organization?: number;
  created_at?: string;
  updated_at?: string;
};
export type ExternalEventLocation = {
  id: number;
  name: string;
  email?: string | null;
  /** * `virtual_conference` - Web Conference
   * `phone` - Phone Call
   * `in_person` - In Person
   * `other` - Other */
  location_type?: "virtual_conference" | "phone" | "in_person" | "other";
};
export type ContactEvent = {
  id: number;
  event_idr: string;
  recurring_root_event_idr: string | null;
  title: string;
  attendees: number[];
  start_date: string;
  end_date: string;
  date_scheduled: string | null;
  cabinet_create_date: string;
  cabinet_update_date: string;
  /** * `SCHEDULED` - SCHEDULED
   * `CANCELED` - CANCELED
   * `IN_PROGRESS` - IN_PROGRESS */
  status: "SCHEDULED" | "CANCELED" | "IN_PROGRESS";
  is_busy: boolean;
  external_event_locations?: ExternalEventLocation[];
  meeting: number | null;
  conference_provider: number | null;
};
export type PaginatedContactEventList = {
  data: ContactEvent[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactFieldChoice = {
  id?: number;
  created_at?: string;
  updated_at?: string;
  label: string;
  created_by?: number | null;
  updated_by?: number | null;
  contact_field_template: number;
};
export type PaginatedContactFieldChoiceList = {
  data: ContactFieldChoice[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactFieldChoiceRequest = {
  id?: number;
  created_at?: string;
  updated_at?: string;
  label: string;
  created_by?: number | null;
  updated_by?: number | null;
  contact_field_template: number;
};
export type PatchedContactFieldChoice = {
  id?: number;
  created_at?: string;
  updated_at?: string;
  label?: string;
  created_by?: number | null;
  updated_by?: number | null;
  contact_field_template?: number;
};
export type ContactFieldOrder = {
  id: number;
  created_at?: string;
  updated_at?: string;
  natural_key?: string | null;
  order: string;
  contact_field_template?: number | null;
  license: number;
};
export type PaginatedContactFieldOrderList = {
  data: ContactFieldOrder[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactFieldOrderRequest = {
  created_at?: string;
  updated_at?: string;
  natural_key?: string | null;
  order: string;
  contact_field_template?: number | null;
  license: number;
};
export type PatchedContactFieldOrder = {
  created_at?: string;
  updated_at?: string;
  natural_key?: string | null;
  order?: string;
  contact_field_template?: number | null;
  license?: number;
};
export type ContactFieldTemplate = {
  id: number;
  created_at?: string;
  updated_at?: string;
  contact_field_choices: ContactFieldChoice[];
  label: string;
  /** * `short_text` - Short Text
   * `long_text` - Long Text
   * `date_type` - Date Type
   * `single_select` - Single-Select
   * `multi_select` - Multi-Select
   * `file_select` - File Select */
  value_type:
    | "short_text"
    | "long_text"
    | "date_type"
    | "single_select"
    | "multi_select"
    | "file_select";
  created_by?: number | null;
  updated_by?: number | null;
  organization: number;
};
export type PaginatedContactFieldTemplateList = {
  data: ContactFieldTemplate[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactFieldTemplateRequest = {
  created_at?: string;
  updated_at?: string;
  label: string;
  /** * `short_text` - Short Text
   * `long_text` - Long Text
   * `date_type` - Date Type
   * `single_select` - Single-Select
   * `multi_select` - Multi-Select
   * `file_select` - File Select */
  value_type:
    | "short_text"
    | "long_text"
    | "date_type"
    | "single_select"
    | "multi_select"
    | "file_select";
  created_by?: number | null;
  updated_by?: number | null;
  organization: number;
};
export type PatchedContactFieldTemplate = {
  created_at?: string;
  updated_at?: string;
  label?: string;
  /** * `short_text` - Short Text
   * `long_text` - Long Text
   * `date_type` - Date Type
   * `single_select` - Single-Select
   * `multi_select` - Multi-Select
   * `file_select` - File Select */
  value_type?:
    | "short_text"
    | "long_text"
    | "date_type"
    | "single_select"
    | "multi_select"
    | "file_select";
  created_by?: number | null;
  updated_by?: number | null;
  organization?: number;
};
export type ContactNote = {
  id: number;
  contacts?: number[];
  teammates?: number[];
  company?: number[];
  allowed_users?: number[];
  created_at?: string;
  updated_at: string;
  body?: string;
  body_plain_text: string;
  is_private?: boolean;
  created_by?: number | null;
  updated_by?: number | null;
};
export type PaginatedContactNoteList = {
  data: ContactNote[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactNoteRequest = {
  contacts?: number[];
  teammates?: number[];
  company?: number[];
  allowed_users?: number[];
  created_at?: string;
  body?: string;
  is_private?: boolean;
  created_by?: number | null;
  updated_by?: number | null;
};
export type PatchedContactNote = {
  contacts?: number[];
  teammates?: number[];
  company?: number[];
  allowed_users?: number[];
  created_at?: string;
  body?: string;
  is_private?: boolean;
  created_by?: number | null;
  updated_by?: number | null;
};
export type ContactTask = {
  id: number;
  contacts?: number[];
  teammates?: number[];
  company?: number[];
  allowed_users?: number[];
  created_at?: string;
  updated_at: string;
  title: string;
  due_date?: string | null;
  /** * `To-Do` - To-Do
   * `Completed` - Completed */
  status?: "To-Do" | "Completed";
  is_private?: boolean;
  created_by?: number | null;
  updated_by?: number | null;
  assignee: number;
};
export type PaginatedContactTaskList = {
  data: ContactTask[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactTaskRequest = {
  contacts?: number[];
  teammates?: number[];
  company?: number[];
  allowed_users?: number[];
  created_at?: string;
  title: string;
  due_date?: string | null;
  /** * `To-Do` - To-Do
   * `Completed` - Completed */
  status?: "To-Do" | "Completed";
  is_private?: boolean;
  created_by?: number | null;
  updated_by?: number | null;
  assignee: number;
};
export type PatchedContactTask = {
  contacts?: number[];
  teammates?: number[];
  company?: number[];
  allowed_users?: number[];
  created_at?: string;
  title?: string;
  due_date?: string | null;
  /** * `To-Do` - To-Do
   * `Completed` - Completed */
  status?: "To-Do" | "Completed";
  is_private?: boolean;
  created_by?: number | null;
  updated_by?: number | null;
  assignee?: number;
};
export type ContactType = {
  id: number;
  name: string;
  color?: string;
};
export type PaginatedContactTypeList = {
  data: ContactType[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type ContactTypeRequest = {
  created_at?: string;
  name: string;
  color?: string;
};
export type PatchedContactType = {
  created_at?: string;
  name?: string;
  color?: string;
};
export type PaginatedContactList = {
  data: Contact[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: {
      company?: {
        [key: string]: Company;
      };
    };
  };
};
export type ContactDateValueMetaRequest = {
  timezone: string;
};
export type ContactFieldMetaRequest = {
  date_value?: ContactDateValueMetaRequest | null;
};
export type ContactFieldRequest = {
  text_value?: string | null;
  choices?: number[] | null;
  meta?: ContactFieldMetaRequest | null;
};
export type ContactRequest = {
  created_at?: string;
  updated_at?: string;
  timezone?: string | null;
  fields?: {
    [key: string]: ContactFieldRequest;
  };
  tags?: number[];
  primary_email?: string;
  all_emails?: string[];
  name: string | null;
  title?: string | null;
  location?: string | null;
  assistant_name?: string | null;
  assistant_email?: string | null;
  phone_number?: string | null;
  linkedin_url?: string | null;
  is_resource?: boolean;
  last_observed_email?: string | null;
  last_observed_name?: string | null;
  avatar?: Blob | null;
  hidden_date?: string | null;
  contact_category?: number | null;
  organization?: number | null;
  contact_type?: number | null;
  company?: number | null;
  private_leaders?: (number | null)[];
};
export type PatchedContact = {
  created_at?: string;
  updated_at?: string;
  timezone?: string | null;
  fields?: {
    [key: string]: ContactFieldRequest;
  };
  tags?: number[];
  primary_email?: string;
  all_emails?: string[];
  name?: string | null;
  title?: string | null;
  location?: string | null;
  assistant_name?: string | null;
  assistant_email?: string | null;
  phone_number?: string | null;
  linkedin_url?: string | null;
  is_resource?: boolean;
  last_observed_email?: string | null;
  last_observed_name?: string | null;
  avatar?: Blob | null;
  hidden_date?: string | null;
  contact_category?: number | null;
  organization?: number | null;
  contact_type?: number | null;
  company?: number | null;
  private_leaders?: (number | null)[];
};
export type MergeContactsInputRequest = {
  /** ID of the primary contact to merge into */
  primary_contact_id: number;
  /** List of contact IDs to merge into the primary contact */
  secondary_contact_ids: number[];
};
export type EventBrief = {
  id: number;
  created_at?: string;
  updated_at: string;
  event_idr?: string | null;
  icaluid?: string | null;
  event_unique_id: string;
  generated_data?: any | null;
  content?: any | null;
  metadata?: any | null;
  notes?: any | null;
  url_key?: string;
  event?: number | null;
  calendar?: number | null;
  leader?: number | null;
  organization?: number;
  create_user?: number | null;
};
export type EventBriefCreateRequest = {
  event_unique_id: string;
  leader_id: number;
  calendar_pk: number;
};
export type PublicOrganization = {
  id: number;
  name: string | null;
  logo: string | null;
  cognito_provider_name: string | null;
  org_code: string | null;
  require_sso: boolean;
  onboarding_call_scheduled: boolean;
};
export type EventBriefExternal = {
  id: number;
  event_idr: string | null;
  icaluid: string | null;
  event_unique_id: string;
  event: ContactEvent;
  calendar: number | null;
  generated_data: any | null;
  content: any | null;
  metadata: any | null;
  notes?: any | null;
  url_key: string;
  leader: number | null;
  organization: PublicOrganization;
  create_user: number | null;
  created_at: string;
  updated_at: string;
};
export type EventBriefExternalRequest = {
  notes?: any | null;
};
export type PatchedEventBriefExternal = {
  notes?: any | null;
};
export type EventBriefRequest = {
  calendar_pk?: number;
  created_at?: string;
  event_idr?: string | null;
  icaluid?: string | null;
  event_unique_id: string;
  generated_data?: any | null;
  content?: any | null;
  metadata?: any | null;
  notes?: any | null;
  url_key?: string;
  event?: number | null;
  calendar?: number | null;
  leader?: number | null;
  organization?: number;
  create_user?: number | null;
};
export type PatchedEventBrief = {
  calendar_pk?: number;
  created_at?: string;
  event_idr?: string | null;
  icaluid?: string | null;
  event_unique_id?: string;
  generated_data?: any | null;
  content?: any | null;
  metadata?: any | null;
  notes?: any | null;
  url_key?: string;
  event?: number | null;
  calendar?: number | null;
  leader?: number | null;
  organization?: number;
  create_user?: number | null;
};
export type LeaderCalendar = {
  calendar: number;
  prevent_conflict?: boolean;
  allow_calendar_analytics?: boolean;
  allow_crm?: boolean;
};
export type Leader = {
  id: number;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  company?: string | null;
  primary_assistant?: number | null;
  industry?: number | null;
  industry_display: string;
  role?: string | null;
  pic_url?: string | null;
  country?: number | null;
  country_code: string;
  location_display: string;
  postal_code?: string | null;
  state?: string | null;
  state_short?: string | null;
  city?: string | null;
  phone_number?: string | null;
  custom?: any;
  color?: string;
  order: number;
  leader_calendars?: LeaderCalendar[];
  organization?: number | null;
};
export type AnalyticsEvent = {
  id: number;
  event_idr: string;
  recurring_root_event_idr: string | null;
  title: string;
  attendees: number[];
  start_date: string;
  end_date: string;
  date_scheduled: string | null;
  cabinet_create_date: string;
  cabinet_update_date: string;
  /** * `SCHEDULED` - SCHEDULED
   * `CANCELED` - CANCELED
   * `IN_PROGRESS` - IN_PROGRESS */
  status: "SCHEDULED" | "CANCELED" | "IN_PROGRESS";
  is_busy: boolean;
  external_event_locations?: ExternalEventLocation[];
  meeting: number | null;
  conference_provider: number | null;
};
export type LeaderRelationship = {
  id: number;
  created_at: string;
  updated_at: string;
  leader: Leader;
  contact: Contact;
  tags: number[];
  next_meeting_data: {
    [key: string]: AnalyticsEvent;
  } | null;
  contact_cadence: ContactCadence | null;
  cadence_due_date: string | null;
  /** * `not_set` - Not Set
   * `meeting_scheduled` - Meeting Scheduled
   * `meeting_scheduled_late` - Meeting Scheduled (Late)
   * `on_track` - On Track
   * `due_soon` - Due Soon
   * `overdue` - Overdue */
  cadence_status:
    | "not_set"
    | "meeting_scheduled"
    | "meeting_scheduled_late"
    | "on_track"
    | "due_soon"
    | "overdue";
  relationship_strength: string;
  relationship_strength_auto: string;
  /** * `weak` - Weak
   * `good` - Good
   * `strong` - Strong */
  relationship_strength_override: ("weak" | "good" | "strong" | null) | null;
  relationship_strength_data: any;
  /** * `manual` - Manual
   * `etl` - ETL */
  source: ("manual" | "etl" | null) | null;
  hidden_date: string | null;
  prev_meeting_data: any | null;
  future_meetings: (any | null)[];
  last_aggregated_next: string;
  last_aggregated_prev: string;
  relationship_type: number | null;
};
export type PaginatedLeaderRelationshipList = {
  data: LeaderRelationship[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type LeaderRelationshipRequest = {
  created_at?: string;
  updated_at?: string;
  leader_id: number;
  contact_id: number;
  tags?: number[];
  /** * `weak` - Weak
   * `good` - Good
   * `strong` - Strong */
  relationship_strength_override?: ("weak" | "good" | "strong" | null) | null;
  relationship_strength_data?: any;
  /** * `manual` - Manual
   * `etl` - ETL */
  source?: ("manual" | "etl" | null) | null;
  hidden_date?: string | null;
  prev_meeting_data?: any | null;
  future_meetings?: (any | null)[];
  last_aggregated_next?: string;
  last_aggregated_prev?: string;
  relationship_type?: number | null;
};
export type PatchedLeaderRelationship = {
  created_at?: string;
  updated_at?: string;
  leader_id?: number;
  contact_id?: number;
  tags?: number[];
  /** * `weak` - Weak
   * `good` - Good
   * `strong` - Strong */
  relationship_strength_override?: ("weak" | "good" | "strong" | null) | null;
  relationship_strength_data?: any;
  /** * `manual` - Manual
   * `etl` - ETL */
  source?: ("manual" | "etl" | null) | null;
  hidden_date?: string | null;
  prev_meeting_data?: any | null;
  future_meetings?: (any | null)[];
  last_aggregated_next?: string;
  last_aggregated_prev?: string;
  relationship_type?: number | null;
};
export type CrmPreferences = {
  id: number;
  reminders_in_app?: boolean;
  reminders_email?: boolean;
  /** Order of columns as array of field names */
  contact_list_column_order: string[];
  /** Hidden columns as array of field names */
  contact_list_hidden_columns: string[];
  /** Order of fields in contact detail view */
  contact_detail_field_order: string[];
  /** Order of columns in the relationship list */
  relationship_list_column_order: string[];
  /** Hidden columns in the relationship list */
  relationship_list_hidden_columns: string[];
  created_at: string;
  updated_at: string;
};
export type CrmPreferencesRequest = {
  reminders_in_app?: boolean;
  reminders_email?: boolean;
  /** Order of columns as array of field names */
  contact_list_column_order: string[];
  /** Hidden columns as array of field names */
  contact_list_hidden_columns: string[];
  /** Order of fields in contact detail view */
  contact_detail_field_order: string[];
  /** Order of columns in the relationship list */
  relationship_list_column_order: string[];
  /** Hidden columns in the relationship list */
  relationship_list_hidden_columns: string[];
};
export type PatchedCrmPreferences = {
  reminders_in_app?: boolean;
  reminders_email?: boolean;
  /** Order of columns as array of field names */
  contact_list_column_order?: string[];
  /** Hidden columns as array of field names */
  contact_list_hidden_columns?: string[];
  /** Order of fields in contact detail view */
  contact_detail_field_order?: string[];
  /** Order of columns in the relationship list */
  relationship_list_column_order?: string[];
  /** Hidden columns in the relationship list */
  relationship_list_hidden_columns?: string[];
};
export type PrivateContact = {
  id: number;
  name: string | null;
  primary_email: string | null;
};
export type LeaderPrivateContacts = {
  id: number;
  private_contacts: PrivateContact[];
};
export type AddRemovePrivateContactInputRequest = {
  contactId: number;
};
export type RelationshipTag = {
  id: number;
  name: string;
  color?: string;
};
export type PaginatedRelationshipTagList = {
  data: RelationshipTag[];
  meta: {
    count?: number;
    next?: string | null;
    previous?: string | null;
    data_map?: object;
  };
};
export type RelationshipTagRequest = {
  name: string;
  color?: string;
};
export type PatchedRelationshipTag = {
  name?: string;
  color?: string;
};
export const {
  useAppCrmCompaniesListQuery,
  useAppCrmCompaniesCreateMutation,
  useAppCrmCompaniesRetrieveQuery,
  useAppCrmCompaniesUpdateMutation,
  useAppCrmCompaniesPartialUpdateMutation,
  useAppCrmCompaniesDestroyMutation,
  useAppCrmCompanyCategoriesListQuery,
  useAppCrmCompanyCategoriesCreateMutation,
  useAppCrmCompanyCategoriesRetrieveQuery,
  useAppCrmCompanyCategoriesUpdateMutation,
  useAppCrmCompanyCategoriesPartialUpdateMutation,
  useAppCrmCompanyCategoriesDestroyMutation,
  useAppCrmContactCadenceListQuery,
  useAppCrmContactCadenceCreateMutation,
  useAppCrmContactCadenceRetrieveQuery,
  useAppCrmContactCadenceUpdateMutation,
  useAppCrmContactCadencePartialUpdateMutation,
  useAppCrmContactCadenceDestroyMutation,
  useAppCrmContactCategoriesListQuery,
  useAppCrmContactCategoriesCreateMutation,
  useAppCrmContactCategoriesRetrieveQuery,
  useAppCrmContactCategoriesUpdateMutation,
  useAppCrmContactCategoriesPartialUpdateMutation,
  useAppCrmContactCategoriesDestroyMutation,
  useAppCrmContactEmailsListQuery,
  useAppCrmContactEmailsCreateMutation,
  useAppCrmContactEmailsRetrieveQuery,
  useAppCrmContactEmailsUpdateMutation,
  useAppCrmContactEmailsPartialUpdateMutation,
  useAppCrmContactEmailsDestroyMutation,
  useAppCrmContactEventsListQuery,
  useAppCrmContactFieldChoicesListQuery,
  useAppCrmContactFieldChoicesCreateMutation,
  useAppCrmContactFieldChoicesRetrieveQuery,
  useAppCrmContactFieldChoicesUpdateMutation,
  useAppCrmContactFieldChoicesPartialUpdateMutation,
  useAppCrmContactFieldChoicesDestroyMutation,
  useAppCrmContactFieldChoicesBulkDeleteCreateMutation,
  useAppCrmContactFieldChoicesBulkUpsertCreateMutation,
  useAppCrmContactFieldOrdersListQuery,
  useAppCrmContactFieldOrdersCreateMutation,
  useAppCrmContactFieldOrdersRetrieveQuery,
  useAppCrmContactFieldOrdersUpdateMutation,
  useAppCrmContactFieldOrdersPartialUpdateMutation,
  useAppCrmContactFieldOrdersDestroyMutation,
  useAppCrmContactFieldTemplatesListQuery,
  useAppCrmContactFieldTemplatesCreateMutation,
  useAppCrmContactFieldTemplatesRetrieveQuery,
  useAppCrmContactFieldTemplatesUpdateMutation,
  useAppCrmContactFieldTemplatesPartialUpdateMutation,
  useAppCrmContactFieldTemplatesDestroyMutation,
  useAppCrmContactNotesListQuery,
  useAppCrmContactNotesCreateMutation,
  useAppCrmContactNotesRetrieveQuery,
  useAppCrmContactNotesUpdateMutation,
  useAppCrmContactNotesPartialUpdateMutation,
  useAppCrmContactNotesDestroyMutation,
  useAppCrmContactTagsListQuery,
  useAppCrmContactTagsCreateMutation,
  useAppCrmContactTagsRetrieveQuery,
  useAppCrmContactTagsUpdateMutation,
  useAppCrmContactTagsPartialUpdateMutation,
  useAppCrmContactTagsDestroyMutation,
  useAppCrmContactTasksListQuery,
  useAppCrmContactTasksCreateMutation,
  useAppCrmContactTasksRetrieveQuery,
  useAppCrmContactTasksUpdateMutation,
  useAppCrmContactTasksPartialUpdateMutation,
  useAppCrmContactTasksDestroyMutation,
  useAppCrmContactTypesListQuery,
  useAppCrmContactTypesCreateMutation,
  useAppCrmContactTypesRetrieveQuery,
  useAppCrmContactTypesUpdateMutation,
  useAppCrmContactTypesPartialUpdateMutation,
  useAppCrmContactTypesDestroyMutation,
  useAppCrmContactsListQuery,
  useAppCrmContactsCreateMutation,
  useAppCrmContactsRetrieveQuery,
  useAppCrmContactsUpdateMutation,
  useAppCrmContactsPartialUpdateMutation,
  useAppCrmContactsDestroyMutation,
  useAppCrmContactsMergeCreateMutation,
  useAppCrmEventBriefsListQuery,
  useAppCrmEventBriefsCreateMutation,
  useAppCrmEventBriefsExternalListQuery,
  useAppCrmEventBriefsExternalCreateMutation,
  useAppCrmEventBriefsExternalRetrieveQuery,
  useAppCrmEventBriefsExternalUpdateMutation,
  useAppCrmEventBriefsExternalPartialUpdateMutation,
  useAppCrmEventBriefsExternalDestroyMutation,
  useAppCrmEventBriefsRetrieveQuery,
  useAppCrmEventBriefsUpdateMutation,
  useAppCrmEventBriefsPartialUpdateMutation,
  useAppCrmEventBriefsDestroyMutation,
  useAppCrmLeaderRelationshipsListQuery,
  useAppCrmLeaderRelationshipsCreateMutation,
  useAppCrmLeaderRelationshipsRetrieveQuery,
  useAppCrmLeaderRelationshipsUpdateMutation,
  useAppCrmLeaderRelationshipsPartialUpdateMutation,
  useAppCrmLeaderRelationshipsDestroyMutation,
  useAppCrmPreferencesListQuery,
  useAppCrmPreferencesCreateMutation,
  useAppCrmPreferencesRetrieveQuery,
  useAppCrmPreferencesUpdateMutation,
  useAppCrmPreferencesPartialUpdateMutation,
  useAppCrmPreferencesDestroyMutation,
  useAppCrmPrivateContactsListQuery,
  useAppCrmPrivateContactsAddPrivateContactCreateMutation,
  useAppCrmPrivateContactsRemovePrivateContactCreateMutation,
  useAppCrmRelationshipTagsListQuery,
  useAppCrmRelationshipTagsCreateMutation,
  useAppCrmRelationshipTagsRetrieveQuery,
  useAppCrmRelationshipTagsUpdateMutation,
  useAppCrmRelationshipTagsPartialUpdateMutation,
  useAppCrmRelationshipTagsDestroyMutation,
} = injectedRtkApi;
